<template>
  <div
    v-if="
      this.userLogin.company_id !== 0 ||
        this.userLogin.roles[0].name == 'super_admin'
    "
  >
    <div>
      <v-card class="mx-auto ml-5 mr-5 my-5" elevation="2">
        <v-data-table
          :headers="headers"
          :items="item_pemasukan"
          disable-pagination
          v-model="selected"
          :show-select="role == 'executive' || role == 'cashier' ? true : false"
          :hide-default-footer="true"
        >
          <template v-slot:top>
            <v-toolbar flat color="white">
              <!-- <v-toolbar-title>List Pemasukan</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider> -->
              <v-row align="center">
                <v-col class="d-flex" cols="12" sm="6">
                  <v-subheader>Kategori: </v-subheader>
                  <v-select
                    style="align-self: center"
                    single-line
                    hide-details
                    v-model="activeCategory"
                    :items="submissionCategoryItems"
                    item-value="id"
                    item-text="name"
                    label="Kategori Pemasukan"
                    @change="onChangeCategory()"
                  />
                </v-col>
                <v-col class="d-flex" cols="12" sm="6">
                  <v-text-field
                    v-model="search"
                    clear-icon="mdi-close-circle"
                    clearable
                    prepend-icon="search"
                    label="Search"
                    single-line
                    hide-details
                    @keyup.enter="handleSearch"
                    @click:clear="resetSearch"
                  ></v-text-field>
                </v-col>
              </v-row>
              <!-- <p>{{activeCategory}}</p> -->
              <v-spacer></v-spacer>
              <v-dialog v-model="dialog" max-width="80%" scrollable>
                <template
                  v-if="
                    (maksPending == 0 || totalPending < maksPending) &&
                      (role == 'executive' || role == 'cashier')
                  "
                  v-slot:activator="{ on }"
                >
                  <v-btn
                    color="primary"
                    small
                    dark
                    class="mb-2"
                    v-on="on"
                    @click="[(isSaved = false)]"
                    >Buat Penawaran Pemasukan</v-btn
                  >
                </template>
                <v-card>
                  <v-card-title>
                    <span class="headline">{{ formTitle }}</span>
                  </v-card-title>

                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex class="pl-4 pr-4 pt-4" xs12>
                        <span class="font-weight-bold subtitle-1"
                          >PILIH CUSTOMER</span
                        >
                      </v-flex>
                      <v-flex class="pl-4 pr-4 pt-4" xs6>
                        <v-text-field
                          hint="Tekan Enter untuk mencari customer"
                          persistent-hint
                          v-model="inputSearch"
                          @keyup.enter="searchUser"
                          label="Masukkan Email / Telp Customer"
                        ></v-text-field>
                      </v-flex>
                      <v-flex class="pl-4 pr-4" xs6 v-if="newUser">
                        <v-card
                          width="100%"
                          outlined
                          color="orange darken-1"
                          dark
                          class="white--text"
                        >
                          <v-icon class="ma-1">info</v-icon
                          ><span
                            style="vertical-align: text-top"
                            class="ma-2 font-weight-bold"
                            >Data customer tidak ditemukan</span
                          >
                          <v-divider></v-divider>
                          <p class="ma-2">
                            Maaf, email atau nomor telepon customer tidak
                            ditemukan.
                          </p>
                        </v-card>
                      </v-flex>
                      <v-flex
                        class="pl-4 pr-4"
                        xs6
                        v-if="!newUser && !userFound"
                      >
                        <v-card
                          width="100%"
                          outlined
                          color="blue darken-1"
                          dark
                          class="white--text"
                        >
                          <v-icon class="ma-1">info</v-icon
                          ><span
                            style="vertical-align: text-top"
                            class="ma-2 caption"
                            >Cari Data Customer</span
                          >
                          <v-divider></v-divider>
                          <p class="ma-2 caption">
                            Masukkan email atau telepon customer.
                          </p>
                        </v-card>
                      </v-flex>
                      <v-flex class="pl-4 pr-4" xs6 v-if="newUser">
                        <v-text-field
                          v-model="editedItemUser.name"
                          label="Name"
                        ></v-text-field>
                      </v-flex>
                      <!-- <v-flex class="pl-4 pr-4" xs6 v-if="newUser">
                  <v-text-field v-model="editedItemUser.username" label="Username"></v-text-field>
                </v-flex> -->
                      <v-flex class="pl-4 pr-4" xs6 v-if="newUser">
                        <v-text-field
                          v-model="editedItemUser.email"
                          label="Email"
                        ></v-text-field>
                      </v-flex>
                      <v-flex class="pl-4 pr-4" xs6 v-if="newUser">
                        <v-text-field
                          v-model="editedItemUser.telp"
                          label="Telp"
                        ></v-text-field>
                      </v-flex>
                      <v-flex class="pl-4 pr-4" xs6 v-if="newUser">
                        <v-autocomplete
                          v-model="editedItemUser.roles[0].id"
                          :items="roles"
                          item-text="name"
                          item-value="id"
                          label="Choose a Role"
                        ></v-autocomplete>
                      </v-flex>
                      <!-- <v-flex class="pl-4 pr-4" xs6 v-if="newUser">
                  <v-text-field type="password" v-model="editedItemUser.password" label="Password"></v-text-field>
                </v-flex>
                <v-flex class="pl-4 pr-4" xs6 v-if="newUser">
                  <v-text-field type="password" v-model="editedItemUser.password_conf" label="Confirmation"></v-text-field>
                </v-flex> -->
                      <v-flex class="pl-4 pr-4" xs6 v-if="userFound">
                        <v-card
                          width="100%"
                          outlined
                          color="green darken-1"
                          dark
                          class="white--text"
                        >
                          <v-icon class="ma-1">info</v-icon
                          ><span
                            style="vertical-align: text-top"
                            class="ma-2 font-weight-bold"
                            >Data customer Ditemukan</span
                          >
                          <v-divider></v-divider>
                          <p class="ma-2">Nama: {{ editedItemUser.name }}</p>
                          <p class="ma-2">Email: {{ editedItemUser.email }}</p>
                          <p class="ma-2">Phone: {{ editedItemUser.telp }}</p>
                        </v-card>
                      </v-flex>
                      <v-flex class="pl-4 pr-4 pt-8" xs12>
                        <span class="font-weight-bold subtitle-1"
                          >DETAIL PEMASUKAN</span
                        >
                      </v-flex>
                      <v-flex class="pl-4 pr-4" xs12>
                        <v-text-field
                          v-model="editedItem.name"
                          label="Nama Pemasukan"
                          required
                        ></v-text-field>
                      </v-flex>
                      <!-- <v-flex class="pl-4 pr-4" xs12 v-if="editedIndex > -1" style="margin-bottom:10px;">
                  <v-select 
                      hide-details
                      v-model="editedItem.category_id" 
                      :items="submissionCategoryItems" 
                      item-value="id"
                      item-text="name" 
                      label="Kategori Submission"/>
                </v-flex> -->
                      <v-flex class="pl-4 pr-4" xs12 v-if="role == 'executive'">
                        <v-text-field
                          v-model="editedItem.keterangan"
                          label="Keterangan Pemasukan"
                          required
                        ></v-text-field>
                      </v-flex>
                      <v-flex class="pl-4 pr-4" xs6>
                        <v-text-field
                          v-model="editedItem.date"
                          type="datetime-local"
                          label="Tanggal"
                          required
                        ></v-text-field>
                      </v-flex>
                      <v-flex class="pl-4 pr-4" xs6>
                        <v-text-field
                          v-model="editedItem.due_date"
                          type="datetime-local"
                          label="Batas Waktu"
                          required
                        ></v-text-field>
                      </v-flex>
                      <v-flex class="pl-4 mt-3 pr-4" xs12>
                        <h6>List Item</h6>
                        <template>
                          <v-data-table
                            :headers="headerListItems"
                            :items="items"
                          >
                            <template v-slot:[`item.harga_jual`]="props">
                              <div v-if="role !== 'executive'">
                                {{ convertCurrency(props.item.harga_jual) }}
                              </div>
                              <v-edit-dialog
                                :return-value.sync="props.item.harga_jual"
                                large
                                persistent
                                @save="editableSave"
                                @cancel="editableCancel"
                                @open="editableOpen"
                                @close="editableClose"
                                v-if="role == 'executive'"
                              >
                                <div>
                                  {{ convertCurrency(props.item.harga_jual) }}
                                </div>
                                <template v-slot:input>
                                  <div class="mt-4 title">Update Price</div>
                                </template>
                                <template v-slot:[`input`]>
                                  <v-text-field
                                    v-model="props.item.harga_jual"
                                    label="Edit"
                                    single-line
                                    counter
                                    autofocus
                                  ></v-text-field>
                                </template>
                              </v-edit-dialog>
                            </template>
                            <template v-slot:[`item.item_name`]="{ item }">
                              <p class="mb-0">{{ item.item_name }}</p>
                              <p v-if="item.start !== null" class="mb-0">
                                Start: {{ item.start }}
                              </p>
                              <p v-if="item.finish !== null" class="mb-0">
                                Finish: {{ item.finish }}
                              </p>
                            </template>
                            <template v-slot:[`item.no`]="{ item }">
                              {{ items.indexOf(item) + 1 + "." }}
                            </template>
                            <template v-slot:[`item.action`]="props">
                              <v-btn
                                icon
                                color="red"
                                slot="activator"
                                @click="removeItem(props.item)"
                              >
                                <v-icon>delete</v-icon>
                              </v-btn>
                            </template>
                          </v-data-table>

                          <v-snackbar
                            v-model="snack"
                            :timeout="3000"
                            :color="snackColor"
                          >
                            {{ snackText }}
                            <v-btn text @click="snack = false">Close</v-btn>
                          </v-snackbar>
                        </template>
                      </v-flex>
                      <v-expansion-panels class="pl-4 mt-3 pr-4">
                        <v-expansion-panel>
                          <v-expansion-panel-header
                            >Tambah Item</v-expansion-panel-header
                          >
                          <v-expansion-panel-content>
                            <v-flex class="pl-4" xs12>
                              <v-layout row wrap align-center>
                                <v-flex xs3 class="pl-4 pr-4 pb-0">
                                  <suggestions
                                    v-model="searchQuery"
                                    :options="options"
                                    :onItemSelected="onSearchItemSelected"
                                    :onInputChange="onInputChange"
                                  >
                                    <div
                                      slot="item"
                                      slot-scope="props"
                                      class="single-item"
                                    >
                                      <template
                                        v-if="
                                          props.item.Icon && props.item.Icon.URL
                                        "
                                      >
                                        <div
                                          class="image-wrap"
                                          :style="{
                                            backgroundImage:
                                              'url(' +
                                              props.item.Icon.URL +
                                              ')',
                                          }"
                                        ></div>
                                      </template>
                                      <span class="name">{{
                                        props.item.item_name
                                      }}</span>
                                    </div>
                                  </suggestions>
                                  <div v-if="itemType === 'MANAGED_ALL'">
                                    <p class="mb-0">Start: {{ itemStart }}</p>
                                    <p class="mb-0">Finish: {{ itemFinish }}</p>
                                  </div>
                                </v-flex>
                                <v-flex xs2 class="pl-4 pr-4">
                                  <v-text-field
                                    type="number"
                                    v-model="inputItem.qty"
                                    label="Jumlah"
                                    required
                                  ></v-text-field>
                                </v-flex>
                                <v-flex xs2 class="pl-4 pr-4">
                                  <div
                                    class="
                                      v-input
                                      v-input--is-label-active
                                      v-input--is-dirty
                                      theme--light
                                      v-text-field v-text-field--is-booted
                                    "
                                  >
                                    <div class="v-input__control">
                                      <div class="v-input__slot">
                                        <div class="v-text-field__slot">
                                          <label
                                            for="customElement1"
                                            class="
                                              v-label v-label--active
                                              theme--light
                                            "
                                            style="
                                              left: 0px;
                                              right: auto;
                                              position: absolute;
                                            "
                                            >Harga</label
                                          >
                                          <money
                                            v-model="inputItem.harga_jual"
                                            id="customElement1"
                                          ></money>
                                        </div>
                                      </div>
                                      <div class="v-text-field__details">
                                        <div class="v-messages theme--light">
                                          <div
                                            class="v-messages__wrapper"
                                          ></div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </v-flex>
                                <v-flex xs2 class="pl-4 pr-4">
                                  <v-text-field
                                    type="number"
                                    v-model="inputItem.discount"
                                    label="Discount"
                                    required
                                  ></v-text-field>
                                </v-flex>
                                <v-flex xs2 class="pl-4 pr-4">
                                  <v-text-field
                                    type="number"
                                    v-model="inputItem.ppn"
                                    label="PPN"
                                    required
                                  ></v-text-field>
                                </v-flex>
                                <v-flex
                                  xs1
                                  class="pl-4 pr-4"
                                  v-if="
                                    searchQuery != '' &&
                                      inputItem.harga_jual != '' &&
                                      inputItem.qty != ''
                                  "
                                >
                                  <v-tooltip top>
                                    <template v-slot:activator="{ on }">
                                      <v-btn
                                        small
                                        icon
                                        color="green"
                                        slot="activator"
                                        v-on="on"
                                        @click="addItem()"
                                      >
                                        <v-icon>check</v-icon>
                                      </v-btn>
                                    </template>
                                    <span> Tambahkan Item </span>
                                  </v-tooltip>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </v-layout>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="orange darken-3" text @click="close"
                      >Cancel</v-btn
                    >
                    <v-btn
                      v-if="items.length > 0"
                      color="blue darken-1"
                      text
                      @click="save"
                      >Save</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <v-dialog v-model="dialogNote" max-width="500px" persistent>
                <v-card>
                  <v-card-title>
                    <span class="headline">Catatan</span>
                  </v-card-title>
                  <v-card-text>
                    {{ note }}
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="dialogNote = false"
                      >Close</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <v-dialog v-model="dialogApproval" max-width="500px" persistent>
                <v-card>
                  <v-card-title>
                    <span class="headline"
                      >Tambah No. Dokumen Rujukan
                      <small>(jika ada)</small></span
                    >
                    <!-- <span class="headline">Catatan {{approval}}</span> -->
                  </v-card-title>
                  <!-- <v-card-text>
              <h4>Apakah anda yakin menyetujui pemasukan ini?</h4>
            </v-card-text> -->
                  <v-card-text>
                    <v-row>
                      <v-col cols="12" sm="6" md="12">
                        <v-text-field
                          v-model="note"
                          label="No. Dokumen Rujukan"
                          required
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="closeApproval()"
                      >Tidak</v-btn
                    >
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="saveApproval(approval)"
                      >Ya</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <v-dialog v-model="dialogEditNote" max-width="500px" persistent>
                <v-card>
                  <v-card-title>
                    <!-- <span class="headline">Catatan {{approval}}</span> -->
                  </v-card-title>
                  <v-card-text>
                    <v-row>
                      <v-col cols="12" sm="6" md="12">
                        <v-text-field
                          v-model="note"
                          label="Catatan"
                          required
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="closeNote()"
                      >Tidak</v-btn
                    >
                    <v-btn color="blue darken-1" text @click="saveNote()"
                      >Ya</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <v-dialog
                v-model="dialog2"
                fullscreen
                hide-overlay
                transition="dialog-bottom-transition"
                scrollable
              >
                <v-card tile>
                  <v-toolbar
                    flat
                    dark
                    class="grey darken-2 text-center"
                    style="max-height: 64px"
                  >
                    <v-toolbar-title>Invoice</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="closeInvoice()">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <v-card-text>
                    <v-row>
                      <v-col cols="8" sm="4" md="8"> </v-col>
                      <v-col cols="4" sm="2" md="4">
                        <p class="font-weight-bold">
                          {{
                            dataUserInvoice.company == null
                              ? "Tidak ada nama"
                              : dataUserInvoice.company.name
                          }}
                        </p>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="8" sm="4" md="8"> </v-col>
                      <v-col cols="4" sm="2" md="4">
                        {{
                          dataUserInvoice.company == null
                            ? "Tidak ada nama"
                            : dataUserInvoice.company.email
                        }}
                      </v-col>
                    </v-row>
                    <v-divider class="pb-3"></v-divider>
                    <v-row>
                      <v-col class="pa-0 pl-3" cols="2" sm="1" md="2">
                        <p class="font-weight-bold">Nama Customer:</p>
                      </v-col>
                      <v-col class="pa-0 pl-3" cols="2" sm="1" md="2">
                        <p class="text-left">
                          {{
                            dataDetails.customer == null
                              ? "Tidak ada nama customer"
                              : dataDetails.customer.name
                          }}
                        </p>
                      </v-col>
                      <v-col cols="4" sm="2" md="4" class="text-center pa-0">
                        <template v-if="dataDetails.status == 'PAID'">
                          <v-chip class="mb-2" color="green" label outlined>
                            <v-icon left>monetization_on</v-icon>
                            {{ dataDetails.status }}
                          </v-chip>
                        </template>
                        <template v-else-if="dataDetails.status == 'PARTIAL'">
                          <v-chip
                            class="mb-2"
                            color="yellow darken-2"
                            label
                            outlined
                          >
                            <v-icon left>monetization_on</v-icon>
                            {{ dataDetails.status }}
                          </v-chip>
                        </template>
                        <template v-else-if="dataDetails.status == 'APPROVED'">
                          <v-chip class="mb-2" color="green" label outlined>
                            <v-icon left>check_circle</v-icon>
                            {{ dataDetails.status }}
                          </v-chip>
                        </template>
                        <template v-else-if="dataDetails.status == 'PENDING'">
                          <v-chip
                            class="mb-2"
                            color="yellow darken-2"
                            label
                            outlined
                          >
                            <v-icon left>queue</v-icon>
                            {{ dataDetails.status }}
                          </v-chip>
                        </template>
                        <template v-else-if="dataDetails.status == 'REJECTED'">
                          <v-chip
                            class="mb-2"
                            color="red darken-2"
                            label
                            outlined
                          >
                            <v-icon left>cancel</v-icon>
                            {{ dataDetails.status }}
                          </v-chip>
                        </template>
                        <template v-else-if="dataDetails.status == 'COMPLETED'">
                          <v-chip class="mb-2" color="green" label outlined>
                            <v-icon left>check_box</v-icon>
                            {{ dataDetails.status }}
                          </v-chip>
                        </template>
                        <template v-else-if="dataDetails.status == 'CANCELED'">
                          <v-chip
                            class="mb-2"
                            color="red darken-2"
                            label
                            outlined
                          >
                            <v-icon left>cancel</v-icon>
                            {{ dataDetails.status }}
                          </v-chip>
                        </template>
                        <template v-else-if="dataDetails.status == 'DRAFT'">
                          <v-chip
                            class="mb-2"
                            color="red darken-2"
                            label
                            outlined
                          >
                            <v-icon left>cancel</v-icon>
                            {{ dataDetails.status }}
                          </v-chip>
                        </template>
                        <template
                          v-else-if="dataDetails.status == 'PARTIAL APPROVED'"
                        >
                          <v-chip
                            class="mb-2"
                            color="yellow darken-2"
                            label
                            outlined
                          >
                            {{ dataDetails.status }}
                          </v-chip>
                        </template>
                      </v-col>
                      <v-col class="pa-0 pl-3" cols="2" sm="1" md="2">
                        <p class="font-weight-bold">Nama Petugas:</p>
                      </v-col>
                      <v-col class="pa-0 pr-3" cols="2" sm="1" md="2">
                        <p class="text-right">
                          {{
                            dataDetails.user == null
                              ? "Tidak ada nama petugas"
                              : dataDetails.user.name
                          }}
                        </p>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col class="pa-0 pl-3" cols="2" sm="1" md="2">
                        <p class="font-weight-bold">Telp Customer:</p>
                      </v-col>
                      <v-col class="pa-0 pl-3" cols="2" sm="1" md="2">
                        <p class="text-left">
                          {{
                            dataDetails.customer == null
                              ? "Tidak ada telpon customer"
                              : dataDetails.customer.telp
                          }}
                        </p>
                      </v-col>
                      <v-col cols="4" sm="2" md="4" class="text-center">
                      </v-col>
                      <v-col class="pa-0 pl-3" cols="2" sm="1" md="2">
                        <p class="font-weight-bold">Invoice Number:</p>
                      </v-col>
                      <v-col class="pa-0 pr-3" cols="2" sm="1" md="2">
                        <p class="text-right">{{ dataDetails.id }}</p>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col class="pa-0 pl-3" cols="2" sm="1" md="2">
                        <p class="font-weight-bold">Tanggal Invoice:</p>
                      </v-col>
                      <v-col class="pa-0 pl-3" cols="2" sm="1" md="2">
                        <p class="text-left">
                          {{ formatdate(dataDetails.date) }}
                        </p>
                      </v-col>
                      <v-col cols="4" sm="2" md="4" class="text-center pa-0">
                      </v-col>
                      <v-col class="pa-0 pl-3" cols="2" sm="1" md="2">
                        <p class="font-weight-bold">Jumlah Pesanan:</p>
                      </v-col>
                      <v-col class="pa-0 pr-3" cols="2" sm="1" md="2">
                        <p class="text-right">{{ dataDetails.items.length }}</p>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col class="pa-0 pl-3" cols="2" sm="1" md="2">
                        <p class="font-weight-bold">Keterangan Pemasukan:</p>
                      </v-col>
                      <v-col class="pa-0 pl-3" cols="2" sm="1" md="2">
                        <p class="text-left">
                          {{
                            dataDetails.keterangan == null
                              ? "Tidak ada keterangan"
                              : dataDetails.keterangan
                          }}
                        </p>
                      </v-col>
                      <v-col cols="4" sm="2" md="4" class="text-center pa-0">
                      </v-col>
                      <v-col class="pa-0 pl-3" cols="2" sm="1" md="2">
                        <p class="font-weight-bold">No. Dokumen Rujukan:</p>
                      </v-col>
                      <v-col class="pa-0 pr-3" cols="2" sm="1" md="2">
                        <p class="text-right">
                          {{
                            dataDetails.note == null
                              ? "Tidak ada catatan"
                              : dataDetails.note
                          }}
                        </p>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col class="pa-0 pl-3" cols="2" sm="1" md="2">
                        <p class="font-weight-bold">Nama Pemasukan:</p>
                      </v-col>
                      <v-col class="pa-0 pl-3" cols="2" sm="1" md="2">
                        <p class="text-left">
                          {{
                            dataDetails.name == null
                              ? "Tidak ada nama"
                              : dataDetails.name
                          }}
                        </p>
                      </v-col>
                      <v-col cols="4" sm="2" md="4" class="text-center pa-0">
                      </v-col>
                      <v-col class="pa-0 pl-3" cols="2" sm="1" md="2">
                        <p class="font-weight-bold">Batas Waktu:</p>
                      </v-col>
                      <v-col class="pa-0 pr-3" cols="2" sm="1" md="2">
                        <p class="text-right">
                          {{ formatdate(dataDetails.due_date) }}
                          <v-btn
                            v-if="
                              dataDetails.status != 'COMPLETED' &&
                                dataDetails.status != 'CANCELED' &&
                                (role == 'accountant' || role == 'cashier')
                            "
                            fab
                            dark
                            small
                            @click="duedateModalVisible = true"
                            color="cyan"
                          >
                            <v-icon dark> mdi-pencil </v-icon>
                          </v-btn>
                        </p>
                      </v-col>
                    </v-row>
                    <v-simple-table
                      fixed-header
                      max-height="300px"
                      class="mb-4"
                    >
                      <template>
                        <thead class="grey lighten-4">
                          <tr>
                            <td
                              v-for="header in headerSubItem"
                              :key="header.text"
                              :class="header.align"
                            >
                              {{ header.text }}
                            </td>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(subItem, index) in dataDetails.items"
                            :key="subItem.id"
                          >
                            <td class="text-left">{{ index + 1 }}.</td>
                            <td class="text-left" v-if="subItem.schedule">
                              <b>{{ subItem.item_name }}</b>
                              <v-btn
                                v-if="
                                  role == 'cashier' &&
                                    dataDetails.status != 'COMPLETED' &&
                                    !(
                                      dateNow >
                                      parseDate(
                                        subItem.schedule.finish.substring(0, 16)
                                      )
                                    )
                                "
                                icon
                                @click="openDialogEdit(subItem)"
                                color="orange"
                              >
                                <v-icon small>edit</v-icon>
                              </v-btn>
                              <br />
                              Mulai:
                              {{ subItem.schedule.start.substring(0, 16) }}
                              <br />
                              Selesai:
                              {{ subItem.schedule.finish.substring(0, 16) }}
                            </td>
                            <td class="text-left" v-else>
                              {{ subItem.item_name }}
                            </td>
                            <td class="text-center" v-if="subItem.schedule">
                              {{
                                Number(subItem.qty) % 1 == 0
                                  ? Number(subItem.qty)
                                  : Number(subItem.qty)
                                      .toFixed(2)
                                      .replace(".00", "")
                              }}
                              Jam
                            </td>
                            <td class="text-center" v-else>
                              {{
                                Number(subItem.qty) % 1 == 0
                                  ? Number(subItem.qty)
                                  : Number(subItem.qty)
                                      .toFixed(2)
                                      .replace(".00", "")
                              }}
                              Pcs
                            </td>
                            <td class="text-center">
                              {{ convertCurrency(subItem.harga_jual) }}
                            </td>
                            <td class="text-center">
                              <span class="green--text"
                                >{{
                                  subItem.discount % 1 == 0
                                    ? subItem.discount
                                    : Number(subItem.discount)
                                        .toFixed(2)
                                        .replace(".00", "")
                                }}%</span
                              >
                            </td>
                            <td class="text-center">
                              <span class="orange--text"
                                >{{
                                  subItem.ppn % 1 == 0
                                    ? subItem.ppn
                                    : Number(subItem.ppn)
                                        .toFixed(2)
                                        .replace(".00", "")
                                }}%</span
                              >
                            </td>
                            <td
                              class="text-right"
                              v-if="subItem.discount != 0 && subItem.ppn != 0"
                            >
                              {{
                                (subItem.qty *
                                  subItem.harga_jual *
                                  (1 - subItem.discount / 100) *
                                  (1 + subItem.ppn / 100)) %
                                  1 ==
                                0
                                  ? convertCurrency(
                                      subItem.qty *
                                        subItem.harga_jual *
                                        (1 - subItem.discount / 100) *
                                        (1 + subItem.ppn / 100)
                                    )
                                  : convertCurrency(
                                      (
                                        subItem.qty *
                                        subItem.harga_jual *
                                        (1 - subItem.discount / 100) *
                                        (1 + subItem.ppn / 100)
                                      )
                                        .toFixed(4)
                                        .replace(".0000", "")
                                    )
                              }}
                            </td>
                            <td
                              class="text-right"
                              v-else-if="subItem.discount != 0"
                            >
                              {{
                                (subItem.qty *
                                  subItem.harga_jual *
                                  (1 - subItem.discount / 100)) %
                                  1 ==
                                0
                                  ? convertCurrency(
                                      subItem.qty *
                                        subItem.harga_jual *
                                        (1 - subItem.discount / 100)
                                    )
                                  : convertCurrency(
                                      (
                                        subItem.qty *
                                        subItem.harga_jual *
                                        (1 - subItem.discount / 100)
                                      )
                                        .toFixed(4)
                                        .replace(".0000", "")
                                    )
                              }}
                            </td>
                            <td class="text-right" v-else-if="subItem.ppn != 0">
                              {{
                                (subItem.qty *
                                  subItem.harga_jual *
                                  (1 + subItem.ppn / 100)) %
                                  1 ==
                                0
                                  ? convertCurrency(
                                      subItem.qty *
                                        subItem.harga_jual *
                                        (1 + subItem.ppn / 100)
                                    )
                                  : convertCurrency(
                                      (
                                        subItem.qty *
                                        subItem.harga_jual *
                                        (1 + subItem.ppn / 100)
                                      )
                                        .toFixed(4)
                                        .replace(".0000", "")
                                    )
                              }}
                            </td>
                            <td class="text-right" v-else>
                              {{
                                (subItem.qty * subItem.harga_jual) % 1 == 0
                                  ? convertCurrency(
                                      subItem.qty * subItem.harga_jual
                                    )
                                  : convertCurrency(
                                      (subItem.qty * subItem.harga_jual)
                                        .toFixed(4)
                                        .replace(".0000", "")
                                    )
                              }}
                            </td>
                          </tr>
                          <tr>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>
                              <h6 class="text-right font-weight-bold">
                                Subtotal:
                              </h6>
                            </td>
                            <td class="text-right">
                              {{ convertCurrency(dataDetails.total) }}
                            </td>
                          </tr>
                          <tr v-if="paid > 0">
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>
                              <h6
                                class="text-right font-weight-bold green--text"
                              >
                                Dibayar:
                              </h6>
                            </td>
                            <td class="text-right green--text">
                              {{ convertCurrency(paid) }}
                            </td>
                          </tr>
                          <tr>
                            <td colspan="5">
                              <v-btn
                                v-if="dataDetails.status != 'REJECTED'"
                                class="ma-2"
                                small
                                color="primary"
                                @click="expand = !expand"
                              >
                                <v-icon class="mr-2">history</v-icon> Riwayat
                                Penerimaan
                              </v-btn>
                              <v-btn
                                class="ma-2"
                                small
                                color="orange darken-2"
                                style="color: #fff"
                                @click="expandNotes = !expandNotes"
                              >
                                <md-icon class="mr-2" style="color: #fff"
                                  >speaker_notes</md-icon
                                >
                                Riwayat Catatan
                              </v-btn>
                              <v-btn
                                v-if="
                                  (userLogin.id == dataDetails.user_id ||
                                    role == 'accountant') &&
                                    dataDetails.status == 'PAID' &&
                                    dataDetails.is_fulfilled == 1
                                "
                                class="ma-2"
                                small
                                color="success"
                                @click="completeSubmission()"
                              >
                                <v-icon class="mr-2">done</v-icon> Invoice
                                Selesai
                              </v-btn>
                              <v-btn
                                v-if="
                                  permission.includes(
                                    'Cancel Completed Submission'
                                  ) && dataDetails.status == 'COMPLETED'
                                "
                                class="ma-2"
                                small
                                color="orange"
                                style="color: #fff"
                                @click="backToPaid()"
                              >
                                <v-icon class="mr-2">cancel</v-icon> Cancel
                                Completed
                              </v-btn>
                              <v-btn
                                class="ma-2"
                                small
                                color="error darken-2"
                                style="color: #fff"
                                @click="expandAttachment = !expandAttachment"
                              >
                                <md-icon class="mr-2" style="color: #fff"
                                  >attach_file</md-icon
                                >
                                Riwayat Attachment
                              </v-btn>
                            </td>
                            <td v-if="dataDetails.total - paid > 0 && paid > 0">
                              <h6 class="text-right font-weight-bold">
                                Total:
                              </h6>
                            </td>
                            <td
                              v-if="dataDetails.total - paid > 0 && paid > 0"
                              class="text-right"
                            >
                              {{ convertCurrency(dataDetails.total - paid) }}
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                    <v-expand-transition>
                      <v-card v-show="expand" outlined>
                        <p
                          class="text-center font-weight-bold"
                          style="margin: 30px 0px"
                        >
                          RIWAYAT PENERIMAAN
                        </p>
                        <v-simple-table fixed-header>
                          <template>
                            <thead class="grey lighten-4">
                              <tr>
                                <td
                                  v-for="header in headerPaymentHistory"
                                  :key="header.text"
                                >
                                  {{ header.text }}
                                </td>
                              </tr>
                            </thead>
                            <tbody v-if="paymentItems != null">
                              <tr
                                v-for="(subItem, index) in paymentItems"
                                :key="subItem.id"
                              >
                                <!-- <td>{{ new Date(subItem.tanggal).toLocaleDateString('id') }}</td> -->
                                <td style="width: 10px">
                                  {{ Number(index) + 1 }}.
                                </td>
                                <td>{{ formatdate(subItem.tanggal) }}</td>
                                <td>
                                  {{ convertCurrency(Number(subItem.jumlah)) }}
                                </td>
                                <td>
                                  {{
                                    subItem.payment_method
                                      ? subItem.payment_method.name
                                      : "-"
                                  }}
                                </td>
                                <td>
                                  <a
                                    v-if="
                                      subItem.transaction_attachment[0] != null
                                    "
                                    :href="
                                      urlAttachment +
                                        '/' +
                                        subItem.transaction_attachment[0]
                                          .location +
                                        '/' +
                                        subItem.transaction_attachment[0].name
                                    "
                                    target="_blank"
                                    >Lihat Attachment</a
                                  >
                                  <p v-else>-</p>
                                </td>
                                <td>
                                  <v-icon
                                    v-if="
                                      dataDetails.status != 'COMPLETED' &&
                                        (role == 'accountant' ||
                                          role == 'cashier')
                                    "
                                    small
                                    class="mr-2"
                                    @click="deletePayment(subItem)"
                                    >delete</v-icon
                                  >
                                  <p v-else>-</p>
                                </td>
                              </tr>
                            </tbody>
                            <tbody v-else>
                              <tr>
                                <td colspan="5">
                                  <p class="font-weight-bold">
                                    No data available.
                                  </p>
                                </td>
                              </tr>
                              <!-- <tr>
                          <td>&nbsp;</td>
                          <td>&nbsp;</td>
                          <td><p class="font-weight-bold">Total</p></td>
                          <td><p>{{ dataDetails.total }}</p></td>
                        </tr> -->
                            </tbody>
                            <v-btn
                              v-if="
                                Number(dataDetails.total) > paid &&
                                  (dataDetails.status == 'APPROVED' ||
                                    dataDetails.status == 'PARTIAL') &&
                                  (role == 'accountant' || role == 'cashier')
                              "
                              small
                              class="white--text"
                              style="margin: 10px"
                              color="green"
                              @click="
                                [
                                  (dialog3 = true),
                                  (jumlahPayment =
                                    Number(dataDetails.total) - paid),
                                ]
                              "
                            >
                              <v-icon>add</v-icon>
                              TAMBAH PEMBAYARAN
                            </v-btn>
                          </template>
                        </v-simple-table>
                      </v-card>
                    </v-expand-transition>
                    <v-expand-transition>
                      <v-card v-show="expandNotes" outlined>
                        <p
                          class="text-center font-weight-bold"
                          style="margin: 30px 0px"
                        >
                          RIWAYAT CATATAN
                        </p>
                        <v-simple-table fixed-header>
                          <template>
                            <thead class="grey lighten-4">
                              <tr>
                                <td
                                  v-for="header in headerNotes"
                                  :key="header.text"
                                >
                                  {{ header.text }}
                                </td>
                              </tr>
                            </thead>
                            <tbody v-if="submissionNotes != null">
                              <tr
                                v-for="(note, index) in submissionNotes"
                                :key="note.id"
                              >
                                <td style="width: 10px">
                                  {{ Number(index) + 1 }}.
                                </td>
                                <td>{{ note.comment }}</td>
                                <td>{{ note.user.name }}</td>
                                <td>{{ formatdate(note.date) }}</td>
                                <td>
                                  <v-icon
                                    v-if="userLogin.id === note.user.id"
                                    small
                                    class="mr-2"
                                    @click="
                                      handleDeleteSubmissionNote(note.id, index)
                                    "
                                    >delete</v-icon
                                  >
                                </td>
                              </tr>
                            </tbody>
                            <tbody v-else>
                              <tr>
                                <td colspan="5">
                                  <p class="font-weight-bold">
                                    No data available.
                                  </p>
                                </td>
                              </tr>
                            </tbody>
                            <v-btn
                              small
                              class="white--text"
                              style="margin: 10px"
                              color="green"
                              @click="noteModalVisible = true"
                            >
                              <v-icon>add</v-icon>
                              TAMBAH CATATAN
                            </v-btn>
                          </template>
                        </v-simple-table>
                      </v-card>
                    </v-expand-transition>
                    <v-expand-transition>
                      <v-card v-show="expandAttachment" outlined>
                        <p
                          class="text-center font-weight-bold"
                          style="margin: 30px 0px"
                        >
                          RIWAYAT ATTACHMENT
                        </p>
                        <v-simple-table fixed-header>
                          <template>
                            <thead class="grey lighten-4">
                              <tr>
                                <td
                                  v-for="header in headerAttachment"
                                  :key="header.text"
                                >
                                  {{ header.text }}
                                </td>
                              </tr>
                            </thead>
                            <tbody v-if="dataAttachment != null">
                              <tr
                                v-for="(attachment, index) in dataAttachment"
                                :key="attachment.id"
                              >
                                <td style="width: 10px">
                                  {{ Number(index) + 1 }}.
                                </td>
                                <td>
                                  <a
                                    v-if="attachment.name != null"
                                    :href="
                                      urlAttachment +
                                        '/' +
                                        attachment.location +
                                        '/' +
                                        attachment.name
                                    "
                                    target="_blank"
                                    >Lihat Attachment</a
                                  >
                                </td>
                                <td>
                                  {{ attachment.user.name }}
                                </td>
                                <td>
                                  <v-icon
                                    v-if="userLogin.id === attachment.user.id"
                                    small
                                    class="mr-2"
                                    @click="
                                      handleDeleteSubmissionAttachment(
                                        attachment.id,
                                        index
                                      )
                                    "
                                    >delete</v-icon
                                  >
                                </td>
                              </tr>
                            </tbody>
                            <tbody v-else>
                              <tr>
                                <td colspan="5">
                                  <p class="font-weight-bold">
                                    No data available.
                                  </p>
                                </td>
                              </tr>
                            </tbody>
                            <v-btn
                              small
                              class="white--text"
                              style="margin: 10px"
                              color="green"
                              @click="attachmentModalVisible = true"
                            >
                              <v-icon>add</v-icon>
                              TAMBAH ATTACHMENT
                            </v-btn>
                          </template>
                        </v-simple-table>
                      </v-card>
                    </v-expand-transition>
                  </v-card-text>
                  <div style="flex: 1 1 auto"></div>
                </v-card>
              </v-dialog>

              <v-dialog v-model="dialog3" max-width="500px" persistent>
                <v-card>
                  <v-card-title> Tambah Pembayaran </v-card-title>
                  <v-card-text>
                    <v-text-field
                      type="datetime-local"
                      v-model="paymentDate"
                      label="Tanggal"
                      required
                    ></v-text-field>
                    <div
                      class="
                        v-input v-input--is-label-active v-input--is-dirty
                        theme--light
                        v-text-field v-text-field--is-booted
                      "
                    >
                      <div class="v-input__control">
                        <div class="v-input__slot">
                          <div class="v-text-field__slot">
                            <label
                              for="customElement2"
                              class="v-label v-label--active theme--light"
                              style="left: 0px; right: auto; position: absolute"
                              >Jumlah</label
                            >
                            <money
                              :precision="4"
                              v-model="jumlahPayment"
                              id="customElement2"
                            ></money>
                          </div>
                        </div>
                        <div class="v-text-field__details">
                          <div class="v-messages theme--light">
                            <div class="v-messages__wrapper"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- <v-text-field type="number" required v-model="jumlahPayment" label="Jumlah"></v-text-field> -->
                    <v-select
                      v-model="paymentMethodSelected"
                      :items="paymentMethod"
                      label="Pilih Wallet"
                      required
                    ></v-select>
                    <v-row>
                      <v-radio-group
                        v-model="takeCamera"
                        row
                      >
                        <v-radio
                          label="Upload Photo"
                          :value="false"
                        ></v-radio>
                        <v-radio
                          label="Take a Picture"
                          :value="true"
                        ></v-radio>
                      </v-radio-group>
                      <v-col v-if="!takeCamera" cols="12" sm="12" md="12" style="left: 0px">
                        <v-file-input
                          accept="image/*,.pdf"
                          label="Upload"
                          outlined
                          dense
                          hide-details="true"
                          v-model="fileAttachmentPayment"
                        ></v-file-input>
                      </v-col>
                      <v-col v-else cols="12" sm="12" md="12" style="left: 0px">
                        <v-row>
                          <v-col cols="12" sm="6" md="6">
                            <div class="border">
                              <vue-web-cam
                                ref="webcam"
                                :device-id="deviceId"
                                width="100%"
                                @started="onStarted"
                                @stopped="onStopped"
                                @error="onError"
                                @cameras="onCameras"
                                @camera-change="onCameraChange"
                              />
                            </div>
                          </v-col>
                          <v-col cols="12" sm="6" md="6">
                            <figure class="figure">
                              <img :src="img" class="img-responsive" />
                            </figure>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" sm="12" md="12" class="pb-0">
                            <v-select
                              :items="devices"
                              label="Device"
                              item-text="label"
                              item-value="deviceId"
                              v-model="camera"
                            ></v-select>
                          </v-col>
                          <v-col cols="12" sm="12" md="12" class="pt-0">
                            <v-btn
                              color="primary"
                              small
                              class="mr-2"
                              @click="onCapture"
                            >Capture Photo</v-btn>
                            <!-- <v-btn
                              color="error"
                              small
                              class="mr-2"
                              @click="onStop"
                            >Stop Camera</v-btn>
                            <v-btn
                              color="success"
                              small
                              @click="onStart"
                            >Start Camera</v-btn> -->
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>

                    <p class="font-italic red--text" v-show="showError">
                      *Jumlah pembayaran tidak boleh melebihi jumlah tagihan!
                    </p>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="closePayment()"
                      >Cancel</v-btn
                    >
                    <v-btn color="blue darken-1" text @click="savePayment()"
                      >Save</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <v-dialog v-model="noteModalVisible" max-width="500px" persistent>
                <v-card>
                  <v-card-title> Tambah Catatan </v-card-title>
                  <v-card-text>
                    <v-textarea
                      rows="3"
                      label="Catatan"
                      v-model="newNote.comment"
                      required
                    ></v-textarea>
                    <v-text-field
                      type="datetime-local"
                      v-model="newNote.date"
                      label="Tanggal"
                    ></v-text-field>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="submissionNoteClose()"
                      >Cancel</v-btn
                    >
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="submissionNoteSave()"
                      >Save</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <v-dialog
                v-model="duedateModalVisible"
                max-width="500px"
                persistent
              >
                <v-card>
                  <v-card-title> Edit Batas Waktu </v-card-title>
                  <v-card-text>
                    <v-text-field
                      type="datetime-local"
                      v-model="editDueDate"
                      label="Batas Waktu"
                    ></v-text-field>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="duedateModalVisible = false"
                      >Cancel</v-btn
                    >
                    <v-btn color="blue darken-1" text @click="editBatasWaktu()"
                      >Save</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <v-dialog
                v-model="attachmentModalVisible"
                max-width="500px"
                persistent
              >
                <v-card>
                  <v-card-title> Tambah Attachment </v-card-title>
                  <v-card-text>
                    <v-col cols="4" sm="2" md="4" style="align-self: center">
                      <span>Upload File</span>
                    </v-col>
                    <v-col cols="12" sm="12" md="12">
                      <v-file-input
                        accept="image/*,.pdf"
                        label="Upload/Update File"
                        outlined
                        dense
                        hide-details="true"
                        v-model="fileAttachment"
                      ></v-file-input>
                    </v-col>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="AttachmentClose()"
                      >Cancel</v-btn
                    >
                    <v-btn color="blue darken-1" text @click="AttachmentSave()"
                      >Save</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-dialog>

              <v-dialog v-model="dialogFulfilled" max-width="500px" persistent>
                <v-card>
                  <v-card-text>
                    <v-row>
                      <v-col cols="12" md="12">
                        <h4>{{ dialogTextEditedFulfilled }}</h4>
                      </v-col>
                    </v-row>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="closeFulfilled()"
                      >Tidak</v-btn
                    >
                    <v-btn color="blue darken-1" text @click="saveFulfilled()"
                      >Ya</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <v-dialog v-model="dialogEdit" max-width="500">
                <v-card>
                  <v-container>
                    <v-form @submit.prevent="editItemLayanan">
                      <v-row align="center">
                        <v-col class="d-flex" cols="12" sm="6">
                          <v-menu
                            v-model="menu"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                v-model="inputStart"
                                label="Tanggal Mulai"
                                prepend-icon="event"
                                readonly
                                v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="inputStart"
                              @change="[onCekJadwal(), (inputEnd = inputStart)]"
                              @input="menu = false"
                            ></v-date-picker>
                          </v-menu>
                        </v-col>

                        <v-col class="d-flex" cols="12" sm="6">
                          <v-select
                            :items="jamItemsStart"
                            v-model="startJam"
                            @change="onCekJadwal"
                            label="Jam"
                          ></v-select>
                        </v-col>

                        <v-col class="d-flex" cols="12" sm="6">
                          <v-menu
                            v-model="menuFinish"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                v-model="inputEnd"
                                label="Tanggal Selesai"
                                prepend-icon="event"
                                readonly
                                v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="inputEnd"
                              @change="onCekJadwal"
                              @input="menuFinish = false"
                            ></v-date-picker>
                          </v-menu>
                        </v-col>

                        <v-col class="d-flex" cols="12" sm="6">
                          <v-select
                            :items="jamItemsFinish"
                            v-model="finishJam"
                            @change="onCekJadwal"
                            label="Jam"
                          ></v-select>
                        </v-col>
                        <v-col
                          class="d-flex"
                          cols="12"
                          sm="12"
                          v-if="jasaItems.length > 0 && availableStock"
                        >
                          <v-select
                            prepend-icon="add_shopping_cart"
                            :items="jasaItems"
                            item-text="name"
                            item-value="id"
                            v-model="selectedJasa"
                            label="Jasa & Layanan"
                          ></v-select>
                        </v-col>
                        <v-col
                          class="d-flex"
                          cols="12"
                          sm="12"
                          v-if="jasaItems.length == 0"
                        >
                          <p class="font-italic red--text caption">
                            *Tidak ditemukan, silahkan cari jadwal lain.
                          </p>
                        </v-col>
                        <v-col
                          class="d-flex"
                          cols="12"
                          sm="12"
                          v-if="jasaItems.length > 0 && !availableStock"
                        >
                          <p class="font-italic red--text caption">
                            *Durasi waktu harus sama dengan data sebelumnya.
                          </p>
                        </v-col>
                      </v-row>
                      <v-btn
                        type="submit"
                        color="primary"
                        v-if="
                          jasaItems.length > 0 && selectedJasa && availableStock
                        "
                        class="mr-4"
                      >
                        Save
                      </v-btn>
                    </v-form>
                  </v-container>
                </v-card>
              </v-dialog>
            </v-toolbar>
            <span
              class="ml-4 caption red--text font-italic"
              v-if="maksPending != 0 && totalPending >= maksPending"
              >*Note: tidak bisa menambahkan pemasukan baru karena sudah
              mencapai batas maksimum {{ maksPending }} pending pemasukan <br />
              <span class="ml-4"
                >*Minta tolong admin dan accountant untuk segera approve
                pemasukan</span
              ></span
            >
            <v-row class="ml-2 mt-4">
              <v-col cols="3">
                <v-btn
                  block
                  depressed
                  small
                  color="primary"
                  height="35px"
                  @click="[(filterModalVisible = true)]"
                >
                  <v-icon>mdi-filter</v-icon>
                  Filter
                </v-btn>
                <v-dialog
                  v-model="filterModalVisible"
                  max-width="500px"
                  persistent
                >
                  <v-card>
                    <v-card-title>
                      Filter berdasarkan
                      {{ swipeMetodeFilterAndCompare[metodeFilter] }}
                    </v-card-title>
                    <v-card-text>
                      <v-radio-group v-model="metodeFilter" row>
                        <v-radio label="tanggal" value="date"></v-radio>
                        <v-radio label="batas waktu" value="due_date"></v-radio>
                      </v-radio-group>
                      <v-text-field
                        type="datetime-local"
                        v-model="fromDateFilter"
                        label="Dari Tanggal"
                      ></v-text-field>
                      <v-text-field
                        type="datetime-local"
                        v-model="toDateFilter"
                        label="Sampai Tanggal"
                      ></v-text-field>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        color="blue darken-1"
                        text
                        @click="[(filterModalVisible = false)]"
                        >Cancel</v-btn
                      >
                      <v-btn
                        color="blue darken-1"
                        text
                        @click="handleFilterByDate"
                        >Update</v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-col>
              <v-col cols="3">
                <v-btn
                  v-if="role == 'accountant' || role == 'executive' || role == 'cashier'"
                  block
                  depressed
                  small
                  color="primary"
                  height="35px"
                  @click="bulkEdit()"
                  :disabled="selected.length > 0 ? false : true"
                >
                  <v-icon>mdi-grease-pencil</v-icon>
                  Bulk Edit
                </v-btn>
                <v-dialog
                  v-model="bulkModalVisible"
                  max-width="500px"
                  persistent
                >
                  <v-card>
                    <v-card-title> Bulk Edit </v-card-title>
                    <v-card-text>
                      <v-select
                        v-model="CategoryBulk"
                        :items="itemKategoriBulk"
                        label="Pilih Bulk"
                      ></v-select>
                      <v-select
                        v-model="kategoriBulk"
                        v-if="CategoryBulk == 'Bulk Kategori'"
                        :items="submissionCategoryItems"
                        item-value="id"
                        item-text="name"
                        label="Kategori Pemasukan"
                      ></v-select>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        color="blue darken-1"
                        text
                        @click="[(bulkModalVisible = false)]"
                        >Cancel</v-btn
                      >
                      <v-btn color="blue darken-1" text @click="handleBulk"
                        >Bulk</v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-col>
              <v-col cols="3" v-if="showCompareButton">
                <v-btn
                  block
                  depressed
                  small
                  dark
                  color="teal"
                  height="35px"
                  @click="[(compareModalVisible = true)]"
                >
                  <v-icon>mdi-compare-horizontal</v-icon>
                  Compare
                </v-btn>
                <v-dialog
                  v-model="compareModalVisible"
                  max-width="500px"
                  persistent
                >
                  <v-card>
                    <v-card-title>
                      Compare berdasarkan
                      {{ swipeMetodeFilterAndCompare[metodeCompare] }}
                    </v-card-title>
                    <v-card-text>
                      <v-radio-group v-model="metodeCompare" row>
                        <v-radio label="tanggal" value="date"></v-radio>
                        <v-radio label="batas waktu" value="due_date"></v-radio>
                      </v-radio-group>
                      <v-text-field
                        type="datetime-local"
                        v-model="fromDateCompare"
                        label="Dari Tanggal"
                      ></v-text-field>
                      <v-text-field
                        type="datetime-local"
                        v-model="toDateCompare"
                        label="Sampai Tanggal"
                      ></v-text-field>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        color="blue darken-1"
                        text
                        @click="[(compareModalVisible = false)]"
                        >Cancel</v-btn
                      >
                      <v-btn
                        color="blue darken-1"
                        text
                        @click="handleCompareByDate"
                        >Update</v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-col>
            </v-row>
            <v-row v-if="showFilteredTitle" class="ml-2">
              <v-col class="d-flex"
                ><h5>
                  Daftar Pemasukan dari
                  {{ swipeMetodeFilterAndCompare[metodeFilter] }}
                  <span style="color: #1976d2" class="font-weight-bold">{{
                    formatdate(fromDateFilter)
                  }}</span>
                  sampai
                  <span style="color: #1976d2" class="font-weight-bold">{{
                    formatdate(toDateFilter)
                  }}</span>
                </h5>
                <v-btn
                  @click="resetFilter"
                  style="margin-left: 10px"
                  outlined
                  small
                  fab
                  color="indigo"
                >
                  <v-icon>mdi-backup-restore</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </template>
          <template v-slot:[`item.date`]="{ item }">
            {{ formatdate(item.date) }}
          </template>
          <template v-slot:[`item.due_date`]="{ item }">
            {{ formatdate(item.due_date) }}
          </template>
          <template v-slot:[`header.status`]>
            <button
              @click="
                [
                  (filterStatusModalVisible = true),
                  (typeTableFilterStatus = 'FILTER'),
                ]
              "
            >
              Status
            </button>
            <v-dialog
              v-model="filterStatusModalVisible"
              max-width="500px"
              persistent
            >
              <v-card>
                <v-card-title> Filter berdasarkan status </v-card-title>
                <v-card-text>
                  <v-select
                    v-model="selectedStatus"
                    :items="listStatus"
                    label="Pilih Status"
                    @click:clear="clearFilterStatus"
                    clearable
                    dense
                    outlined
                  ></v-select>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="blue darken-1"
                    text
                    @click="[(filterStatusModalVisible = false)]"
                    >Cancel</v-btn
                  >
                  <v-btn
                    color="blue darken-1"
                    text
                    @click="handleFilterByStatus(typeTableFilterStatus)"
                    >Update</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
          </template>
          <template v-slot:[`item.alreadyread`]="{ item }">
            <v-tooltip
              top
              v-if="
                item.alreadyread.find(
                  (element) => element.user_id == userLogin.id
                )
              "
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  icon
                  class="text-center"
                  color="dark"
                  slot="activator"
                  v-on="on"
                  ><v-icon>visibility</v-icon>
                </v-btn>
              </template>
              <div v-for="i in item.alreadyread" :key="i.id">
                <span v-if="i.user.id === userLogin.id">Anda</span>
                <span v-else>{{ i.user.name }}</span>
                <!-- <span v-else>No match</span> -->
              </div>
            </v-tooltip>
            <v-tooltip top v-else>
              <template v-slot:activator="{ on }">
                <v-btn
                  icon
                  color="green"
                  class="text-center"
                  slot="activator"
                  v-on="on"
                  @click="changeRead(item)"
                  ><v-icon>visibility_off</v-icon>
                </v-btn>
              </template>
              <div v-if="item.alreadyread.length > 0">
                <div v-for="i in item.alreadyread" :key="i.id">
                  <span>{{ i.user.name }}</span>
                </div>
              </div>
              <div v-else>
                <span>No Watch</span>
              </div>
            </v-tooltip>
          </template>
          <template v-slot:[`item.is_fulfilled`]="{ item }">
            <v-chip
              small
              class="ma-2"
              label
              style="color: #fff"
              :color="item.is_fulfilled ? '#27ae60' : '#fa8231'"
              >{{ item.is_fulfilled ? "Fulfilled" : "Unfulfilled" }}</v-chip
            >
          </template>
          <template v-slot:[`item.no`]="{ item }">
            {{
              item_pemasukan.indexOf(item) +
                1 +
                (currentPage - 1) * pageSize +
                "."
            }}
          </template>
          <template v-slot:[`item.status`]="{ item }">
            <v-chip
              small
              class="ma-2"
              label
              :text-color="statusTextColor[item.status.replace(/\s/g, '')]"
              :color="statusColor[item.status.replace(/\s/g, '')]"
              >{{ item.status }}</v-chip
            >
          </template>
          <template v-slot:[`item.total`]="{ item }">
            {{ convertCurrency(item.total) }}
          </template>
          <template v-slot:[`item.paid`]="{ item }">
            {{ convertCurrency(item.paid) }}
          </template>
          <template
            v-if="role == 'accountant'"
            v-slot:[`item.action`]="{ item }"
          >
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon
                  v-show="item.status == 'PENDING'"
                  small
                  class="mr-2"
                  v-on="on"
                  @click="editStatusApprove(item)"
                  >done_outline</v-icon
                >
              </template>
              <span>Approve</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon
                  v-show="item.status == 'PENDING'"
                  small
                  class="mr-2"
                  v-on="on"
                  @click="editStatusRefuse(item)"
                  >cancel</v-icon
                >
              </template>
              <span>Reject</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon
                  v-show="
                    item.status == 'APPROVED' ||
                      item.status == 'PARTIAL' ||
                      item.status == 'PAID' ||
                      item.status == 'COMPLETED'
                  "
                  class="mr-2"
                  small
                  v-on="on"
                  @click="onClickPrint(item)"
                  >print</v-icon
                >
              </template>
              <span>Print</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon
                  v-if="item.status != 'DRAFT'"
                  small
                  class="mr-2"
                  v-on="on"
                  @click="modalDetail(item)"
                  >info</v-icon
                >
              </template>
              <span>Detail</span>
            </v-tooltip>
            <v-icon
              v-show="
                (item.status == 'DRAFT' || item.status == 'PENDING' || (item.total == 0 && item.status == 'CANCELED')) &&
                  (role == 'executive' || role == 'cashier')
              "
              small
              @click="deleteItemDraft(item)"
              >delete</v-icon
            >
          </template>
          <template v-else v-slot:[`item.action`]="{ item }">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon
                  v-show="
                    (item.status == 'APPROVED' ||
                      item.status == 'PARTIAL' ||
                      item.status == 'PAID' ||
                      item.status == 'COMPLETED') &&
                      item.is_fulfilled === 0
                  "
                  small
                  class="mr-2"
                  v-on="on"
                  @click="editStatusFulfilled(item, 'ACCEPT_FULFILLED')"
                  >done_outline</v-icon
                >
              </template>
              <span>Fulfilled</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon
                  v-show="
                    (item.status == 'APPROVED' ||
                      item.status == 'PARTIAL' ||
                      item.status == 'PAID') &&
                      item.is_fulfilled === 0
                  "
                  small
                  class="mr-2"
                  v-on="on"
                  @click="editStatusFulfilled(item, 'ACCEPT_NOT_FULFILLED')"
                  >close</v-icon
                >
              </template>
              <span>Not Fulfilled</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon
                  v-show="item.status == 'PARTIAL APPROVED' && role === 'admin'"
                  small
                  class="mr-2"
                  v-on="on"
                  @click="editStatusApprove(item)"
                  >done_outline</v-icon
                >
              </template>
              <span>Approve</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon
                  v-show="
                    statusCanEdit.includes(item.status) &&
                      (role == 'executive' || role == 'cashier')
                  "
                  v-on="on"
                  small
                  class="mr-2"
                  @click="editItem(item)"
                  >edit</v-icon
                >
              </template>
              <span>Edit</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon
                  v-show="
                    item.status == 'APPROVED' ||
                      item.status == 'PARTIAL' ||
                      item.status == 'PAID' ||
                      item.status == 'COMPLETED'
                  "
                  class="mr-2"
                  small
                  v-on="on"
                  @click="onClickPrint(item)"
                  >print</v-icon
                >
              </template>
              <span>Print</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon
                  v-if="item.status != 'DRAFT'"
                  small
                  class="mr-2"
                  v-on="on"
                  @click="modalDetail(item)"
                  >info</v-icon
                >
              </template>
              <span>Detail</span>
            </v-tooltip>
            <v-icon
              v-show="
                (item.status == 'DRAFT' || item.status == 'PENDING' || (item.total == 0 && item.status == 'CANCELED')) &&
                  (role == 'executive' || role == 'cashier')
              "
              small
              @click="deleteItemDraft(item)"
              >delete</v-icon
            >
            <!-- <v-icon v-show="item.status=='REJECTED' || item.status=='APPROVED'" class="mr-2" small @click="noteModal(item)">announcement</v-icon> -->
          </template>
          <template v-slot:no-data>
            <span class="text-center">No data available.</span>
          </template>
          <template v-slot:footer>
            <v-divider></v-divider>
            <div style="padding: 0 5em">
              <div :class="`d-flex justify-end`">
                <h5>
                  Total Pemasukan:
                  <b style="color: #43a047">{{
                    convertCurrency(totalPemasukan)
                  }}</b>
                </h5>
              </div>
            </div>
          </template>
        </v-data-table>
        <div style="padding: 20px" class="d-flex">
          <v-col class="d-flex" cols="12" sm="1">
            <small style="margin-top: 30px">Item show</small>
          </v-col>
          <v-col class="d-flex" cols="12" sm="">
            <v-select
              v-model="pageSize"
              :items="pageSizes"
              @change="handlePageSizeChange"
              style="font-size: 10px"
            ></v-select>
          </v-col>
          <v-col class="d-flex" cols="12" sm="12">
            <v-pagination
              style="width: auto"
              v-model="currentPage"
              :length="totalPages"
              total-visible="10"
              next-icon="mdi-menu-right"
              prev-icon="mdi-menu-left"
              @input="handlePageChange"
            ></v-pagination>
            <small style="margin-top: 30px"
              >{{ from }}-{{ to }} of {{ totalData }}</small
            >
          </v-col>
        </div>
      </v-card>
    </div>
    <v-spacer></v-spacer>
    <div id="compareTable">
      <v-data-table
        v-if="showCompareTable"
        :headers="headers.filter((header) => header.value !== 'action')"
        :items="item_pemasukan_compared"
        class="elevation-1 mt-5"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title
              ><h5>
                Daftar Pemasukan dari
                {{ swipeMetodeFilterAndCompare[metodeFilter] }}
                <span style="color: #009688" class="font-weight-bold">{{
                  formatdate(fromDateCompare)
                }}</span>
                sampai
                <span style="color: #009688" class="font-weight-bold">{{
                  formatdate(toDateCompare)
                }}</span>
              </h5></v-toolbar-title
            >
            <v-spacer></v-spacer>
          </v-toolbar>
        </template>
        <template v-slot:[`header.status`]>
          <button
            @click="
              [
                (filterStatusModalVisible = true),
                (typeTableFilterStatus = 'COMPARE'),
              ]
            "
          >
            Status
          </button>
        </template>
        <template v-slot:[`item.status`]="{ item }">
          <v-chip
            small
            class="ma-2"
            label
            :text-color="statusTextColor[item.status.replace(/\s/g, '')]"
            :color="statusColor[item.status.replace(/\s/g, '')]"
            >{{ item.status }}</v-chip
          >
        </template>
        <template v-slot:[`item.alreadyread`]="{ item }">
          <v-tooltip
            top
            v-if="
              item.alreadyread.find(
                (element) => element.user_id == userLogin.id
              )
            "
          >
            <template v-slot:activator="{ on }">
              <v-btn
                icon
                class="text-center"
                color="dark"
                slot="activator"
                v-on="on"
                ><v-icon>visibility</v-icon>
              </v-btn>
            </template>
            <div v-for="i in item.alreadyread" :key="i.id">
              <span v-if="i.user.id === userLogin.id">Anda</span>
              <span v-else>{{ i.user.name }}</span>
              <!-- <span v-else>No match</span> -->
            </div>
          </v-tooltip>
          <v-tooltip top v-else>
            <template v-slot:activator="{ on }">
              <v-btn
                icon
                color="green"
                class="text-center"
                slot="activator"
                v-on="on"
                @click="changeRead(item)"
                ><v-icon>visibility_off</v-icon>
              </v-btn>
            </template>
            <div v-if="item.alreadyread.length > 0">
              <div v-for="i in item.alreadyread" :key="i.id">
                <span>{{ i.user.name }}</span>
              </div>
            </div>
            <div v-else>
              <span>No Watch</span>
            </div>
          </v-tooltip>
        </template>
        <template v-slot:[`item.is_fulfilled`]="{ item }">
          <v-chip
            small
            class="ma-2"
            label
            style="color: #fff"
            :color="item.is_fulfilled ? '#27ae60' : '#fa8231'"
            >{{ item.is_fulfilled ? "Fulfilled" : "Unfulfilled" }}</v-chip
          >
        </template>
        <template v-slot:[`item.no`]="{ item }">
          {{
            item_pemasukan_compared.indexOf(item) +
              1 +
              (currentPage - 1) * pageSize +
              "."
          }}
        </template>
        <template v-slot:[`item.total`]="{ item }">
          <span>{{ convertCurrency(item.total) }}</span>
        </template>
        <template v-slot:no-data>
          <span class="text-center">No data available.</span>
        </template>
        <template v-slot:footer>
          <v-divider></v-divider>
          <div style="padding: 0 5em">
            <div :class="`d-flex justify-end`">
              <h5>
                Total Pemasukan:
                <b style="color: #43a047">{{
                  convertCurrency(totalPemasukanCompared)
                }}</b>
              </h5>
            </div>
          </div>
        </template>
      </v-data-table>
    </div>
  </div>

  <div v-else class="content">
    <div class="md-layout">
      <nav-tabs-card>
        <template slot="content">
          <h3 class="text-center">
            Silahkan tambahkan data company profile terlebih dahulu
          </h3>
        </template>
      </nav-tabs-card>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import {
  forEach,
  slice,
  isEmpty,
  orderBy,
  find,
  countBy,
  remove,
} from "lodash";
import { NavTabsCard } from "@/components";
import itemTemplate from "@/components/ItemTemplate.vue";
import dayjs from "dayjs";
import debounce from "debounce";
import { formatCurrency } from "@/libs/number";
import moment from "moment";
import { WebCam } from "vue-web-cam";

export default {
  components: {
    NavTabsCard,
    "vue-web-cam": WebCam,
  },
  data: () => ({
    searchQuery: "",
    search: null,
    selectedSearchItem: null,
    options: {
      placeholder: "Nama Produk",
      debounce: 2000,
    },
    itemTemplate,
    search: "",
    inputItem: {
      product_id: 0,
      item_name: "",
      harga_jual: "",
      discount: "",
      ppn: "",
      qty: "",
    },
    loadingItem: false,
    item_items: [],
    isSaved: false,
    isCustom: false,
    dialog2: false,
    dialog3: false,
    dialog: false,
    dialogNote: false,
    dialogApproval: false,
    dialogEditNote: false,
    dialogDetail: false,
    noteModalVisible: false,
    expand: false,
    expandNotes: false,
    userLogin: {},
    note: "",
    approval: "",
    role: "",
    permission: [],
    showError: false,
    dataUserInvoice: {},
    produk: [],
    // editable component
    snack: false,
    snackColor: "",
    snackText: "",
    pagination: {},
    // end editable component
    headers: [
      {
        text: "No.",
        align: "left",
        value: "no",
        filterable: false,
      },
      {
        text: "Nama",
        align: "left",
        value: "name",
      },
      { text: "Total Harga", value: "total", filterable: false },
      { text: "Total Paid", value: "paid", filterable: false },
      { text: "Tanggal", value: "date", filterable: false },
      { text: "Batas Waktu", value: "due_date", filterable: false },
      { text: "Mark", value: "alreadyread", filterable: false },
      { text: "Status", value: "status", filterable: false, name: "status" },
      {
        text: "Fulfillment",
        align: "left",
        value: "is_fulfilled",
        filterable: false,
      },
      { text: "Actions", value: "action", sortable: false, filterable: false },
    ],
    totalPemasukan: "Loading...",
    item_pemasukan: [],
    item_pemasukan_compared: [],
    totalPemasukanCompared: "Loading...",
    dataDetails: {
      items: [],
    },
    editedIndex: -1,
    editedItem: {
      note: "",
      total: "",
      partner_id: "",
      date: dayjs().format("YYYY-MM-DDTHH:mm"),
      due_date: dayjs()
        .add(7, "day")
        .format("YYYY-MM-DDTHH:mm"),
    },
    defaultItem: {
      total: "",
      partner_id: "",
    },
    items: [],
    paymentItems: null,
    submissionNotes: null,
    headerListItems: [
      {
        text: "No.",
        align: "left",
        value: "no",
      },
      { text: "Nama Item", align: "text-left", value: "item_name" },
      { text: "Jumlah", align: "text-center", value: "qty" },
      { text: "Harga", align: "text-center", value: "harga_jual" },
      { text: "Diskon", align: "text-center", value: "discount" },
      { text: "PPN", align: "text-center", value: "ppn" },
      { text: "Actions", value: "action", sortable: false },
    ],
    headerSubItem: [
      {
        text: "No.",
        align: "left",
      },
      { text: "Nama Item", align: "text-left" },
      { text: "Jumlah", align: "text-center" },
      { text: "Harga", align: "text-center" },
      { text: "Diskon", align: "text-center" },
      { text: "PPN", align: "text-center" },
      { text: "Total Harga", align: "text-right" },
    ],
    headerPaymentHistory: [
      {
        text: "No.",
        align: "left",
      },
      { text: "Tanggal" },
      { text: "Jumlah" },
      { text: "Wallet" },
      { text: "Attachment" },
      { text: "Action" },
    ],
    paymentMethod: [],
    headerNotes: [
      {
        text: "No.",
        align: "left",
      },
      { text: "Catatan" },
      { text: "User" },
      { text: "Tanggal" },
      { text: "Action" },
    ],
    newNote: {
      comment: "",
      date: dayjs().format("YYYY-MM-DDTHH:mm"),
    },
    paid: 0,
    jumlahPayment: 0,
    paymentMethodSelected: "",
    paymentDate: "",
    initSearch: "",
    customer: null,
    customerOptions: [],
    loadingCustomer: false,

    showFormNewCustomer: false,
    defaultNewCustomer: {
      name: "",
      address: "",
      city: "",
    },
    statusCanEdit: ["DRAFT", "PENDING", "REJECTED"],
    statusColor: {
      DRAFT: "yellow",
      CANCELED: "red",
      REJECTED: "red",
      FAILED: "red",
      REFUNDED: "orange",
      PENDING: "secondary",
      PARTIAL: "default",
      PAID: "green lighten-1",
      PARTIALAPPROVED: "blue-grey darken-1",
      APPROVED: "primary",
      COMPLETED: "success",
    },
    statusTextColor: {
      // "DRAFT": "yellow",
      // "CANCELED": "red",
      // "REJECTED": "red",
      // "FAILED": "red",
      // "REFUNDED": "orange",
      // "PENDING": "secondary",
      // "PARTIAL": "default",
      // "PAID": "green lighten-1",
      PARTIALAPPROVED: "white",
      // "APPROVED": "primary",
      // "COMPLETED": "success"
    },
    maksPending: 0,
    totalPending: 0,
    inputSearch: null,
    newUser: false,
    userFound: false,
    editedItemUser: {
      name: "",
      username: "",
      password: "",
      telp: "",
      email: "",
      roles: [
        {
          id: "",
          name: "",
        },
      ],
    },
    defaultItemUser: {
      name: "",
      username: "",
      password: "",
      telp: "",
      email: "",
      roles: [
        {
          id: "",
          name: "",
        },
      ],
    },
    roles: [],
    listStatus: [
      "DRAFT",
      "PENDING",
      "PARTIAL APPROVED",
      "APPROVED",
      "PARTIAL",
      "PAID",
      "COMPLETED",
      "CANCELED",
      "REFUNDED",
      "FAILED",
      "REJECTED",
    ],
    selectedStatus: null,
    selectedDateFrom: null,
    selectedDateTo: null,

    swipeMetodeFilterAndCompare: {
      date: "tanggal",
      due_date: "batas waktu",
    },
    // Start Filter Modal
    filterModalVisible: false,
    showFilteredTitle: false,
    fromDateFilter: "",
    toDateFilter: "",
    metodeFilter: "date",
    // End Filter Modal

    // Compare Modal
    showCompareButton: false,
    compareModalVisible: false,
    showCompareTable: false,
    fromDateCompare: "",
    toDateCompare: "",
    metodeCompare: "date",

    // Filter Status Modal
    filterStatusModalVisible: false,
    typeTableFilterStatus: "FILTER",

    // Submission Categories
    activeCategory: null,
    submissionCategoryItems: [],
    dialogFulfilled: false,
    dialogTextEditedFulfilled: "",
    editedFulfilled: 0,
    fileAttachment: null,
    expandAttachment: false,
    headerAttachment: [
      {
        text: "No.",
        align: "left",
      },
      { text: "Attachment" },
      { text: "Uploader" },
      { text: "Action" },
    ],
    dataAttachment: null,
    attachmentModalVisible: false,
    urlAttachment: process.env.VUE_APP_ENDPOINT_ATTACHMENT_URL,
    fileAttachmentPayment: null,
    selected: [],
    CategoryBulk: null,
    pageSizes: [10, 50, 100],
    currentPage: 1,
    totalPages: 0,
    pageSize: 10,
    from: 0,
    to: 0,
    totalData: 0,
    itemKategoriBulk: ["Bulk Kategori"],
    bulkModalVisible: false,
    kategoriBulk: null,
    selectedItem: {},
    menu: false,
    menuFinish: false,
    jamItemsStart: [],
    jamItemsFinish: [],
    startJam: null,
    finishJam: null,
    inputStart: null,
    inputEnd: null,
    start: null,
    end: null,
    selectedJasa: null,
    jasaItems: [],
    available: [],
    dialogEdit: false,
    selectedItem: {},
    availableStock: false,
    duedateModalVisible: false,
    editDueDate: null,
    dateNow: dayjs(Date.now()).format("YYYY-MM-DDTHH:mm"),
    itemStart: null,
    itemFinish: null,
    itemType: null,
    img: null,
    camera: null,
    deviceId: null,
    devices: [],
    takeCamera: false,
  }),

  computed: {
    ...mapGetters({
      getRoles: "user/getRoles",
      getSubmissionNote: "submission_note/getSubmissionNoteBySubmissionId",
    }),

    device() {
      return this.devices.find((n) => n.deviceId === this.deviceId);
    },

    formTitle() {
      return this.editedIndex === -1
        ? "Tambah Penawaran Pemasukan"
        : "Edit Penawaran Pemasukan";
    },
  },
  watch: {
    camera(id) {
      this.deviceId = id;
    },
    devices() {
      // Once we have a list select the first one
      const [first, ...tail] = this.devices;
      if (first) {
        this.camera = first.deviceId;
        this.deviceId = first.deviceId;
      }
    },
    dialog(val) {
      if (!val) return false;
      val || this.close();
    },
    initSearch(value) {
      if (!value) return;
      debounce(this.searchCustomerByName, 200)(value, this);
    },
    // search(value){
    //   if(!value) return;
    //   debounce(this.inputChange,200)(value,this)
    // },
    customer(val) {
      //console.log(this.customer)
      let custom = this.customer;
      val || this.close();
    },
    item_pemasukan() {
      return orderBy(this.item_pemasukan, ["id", "status"], ["desc", "DRAFT"]);
    },
  },
  methods: {
    onCapture() {
      this.img = this.$refs.webcam.capture();
    },
    onStarted(stream) {
      console.log("On Started Event", stream);
    },
    onStopped(stream) {
      console.log("On Stopped Event", stream);
    },
    onStop() {
      this.$refs.webcam.stop();
    },
    onStart() {
      this.$refs.webcam.start();
    },
    onError(error) {
      console.log("On Error Event", error);
    },
    onCameras(cameras) {
      this.devices = cameras;
      console.log("On Cameras Event", cameras);
    },
    onCameraChange(deviceId) {
      this.deviceId = deviceId;
      this.camera = deviceId;
      console.log("On Camera Change Event", deviceId);
    },
    async handleBulk() {
      let is_fulfilled = 1;
      let submission_ids = [];
      this.selected.forEach(function tampil(element, index, array) {
        submission_ids.push(element.id);
      });
      let response = await this.createBulk({
        is_fulfilled,
        submission_ids,
        CategoriBulk: this.CategoryBulk,
        kategoriBulk: this.kategoriBulk,
      });

      if (response.data.success) {
        if (this.CategoryBulk == "Bulk Kategori") {
          this.activeCategory = this.kategoriBulk;
          this.activeCategory = find(
            this.submissionCategoryItems,
            (categoryItem) => categoryItem.id == this.activeCategory
          );
        }

        this.reloadData();

        this.bulkModalVisible = false;
        this.selected = [];
        return this.$notify({
          group: "custom-notification",
          type: "success",
          title: "Berhasil!",
          text: "Bulk Data Berhasil di lakukan",
        });
      }
    },
    async bulkEdit() {
      this.bulkModalVisible = true;
      let kategori = ["APPROVED", "PARTIAL", "PAID", "COMPLETED"];
      let sumFullfilment = 0;
      let sumCompleted = 0;
      this.selected.forEach(function tampil(element, index, array) {
        if (kategori.includes(element.status)) {
          if (element.is_fulfilled === 1) {
            sumFullfilment++;
          }
        } else {
          sumFullfilment++;
        }
        if (element.status != "PAID") {
          sumCompleted++;
        }
      });
      this.itemKategoriBulk = ["Bulk Kategori"];
      if (sumFullfilment == 0) {
        this.itemKategoriBulk.push("Bulk Fulfillment");
      }
      if (sumCompleted == 0) {
        this.itemKategoriBulk.push("Bulk Completed");
      }
    },
    formatdate(value) {
      return moment(value).format("DD-MM-YYYY HH:mm");
    },
    ...mapMutations({
      setSubmissionId: "submission_note/SET_SUBMISSION_ID",
    }),
    ...mapActions({
      createPemasukan: "pemasukan/createPemasukan",
      updatePemasukan: "pemasukan/updatePemasukan",
      updateStatusPemasukan: "pemasukan/updateStatusPemasukan",
      getTransaction: "transaction/getTransactionBySubmissionId",
      getPemasukanByIdPOS: "pemasukan/getPemasukanByIdPOS",
      createTransaction: "transaction/createTransaction",
      deleteTransaction: "transaction/deleteTransaction",
      getUserById: "user/getUserById",
      getUserByName: "user/getUserByName",
      searchItem: "item/searchItem",
      deletePemasukan: "pemasukan/deletePemasukan",
      getMaksimumSubmissions: "user/getMaksimumSubmissions",
      getUsersByEmailOrPhone: "user/getUsersByEmailOrPhone",
      createUserSubmission: "user/createUserSubmission",
      getPaymentMethods: "payment_methods/getPaymentMethods",
      getListPaymentMethods: "payment_methods/getListPaymentMethods",
      createSubmissionNote: "submission_note/createSubmissionNote",
      deleteSubmissionNote: "submission_note/deleteSubmissionNote",
      filterPemasukan: "pemasukan/filterPemasukan",
      getSubmissionCategories: "submission_categories/getSubmissionCategories",
      dataPemasukan: "pemasukan/getPemasukan",
      getAttachmentSubmission: "pemasukan/getAttachmentSubmission",
      uploadSubmissionAttachment: "pemasukan/uploadSubmissionAttachment",
      removeAttachmentSubmission: "pemasukan/removeAttachmentSubmission",
      createBulk: "pemasukan/createBulk",
      deleteRead: "pemasukan/deleteRead",
      deletePerson: "pemasukan/deletePerson",
      storeRead: "pemasukan/createRead",
      getProductJasaHargaJual: "products/getProductJasaHargaJual",
      cekJadwal: "jadwal/cekJadwal",
      updateJadwal: "jadwal/updateJadwal",
      updateItem: "products/updateItem",
      editDueDateDetail: "pemasukan/editDueDateDetail",
    }),
    openDialogEdit(item) {
      this.dialogEdit = true;
      this.selectedItem = item;
    },
    async editItemLayanan() {
      const allProductJasa = await this.getProductJasaHargaJual(
        Number(this.selectedItem.harga_jual)
      );
      const selectedProduct = find(
        allProductJasa.data.attributes,
        (jasa) => jasa.id == this.selectedJasa
      );

      const start = new Date(this.inputStart + " " + this.startJam);
      const end = new Date(this.inputEnd + " " + this.finishJam);

      const itemPesanan = {
        id: this.selectedItem.id,
        product_id: selectedProduct.id,
        item_name: selectedProduct.name,
        mulai: this.inputStart + " " + this.startJam,
        selesai: this.inputEnd + " " + this.finishJam,
      };

      const responseItem = await this.updateItem(itemPesanan);

      const payloadJadwal = {
        id: this.selectedItem.schedule.id,
        product_id: selectedProduct.id,
        start: this.inputStart + " " + this.startJam,
        finish: this.inputEnd + " " + this.finishJam,
      };
      const responseJadwal = await this.updateJadwal(payloadJadwal);

      this.dialogEdit = false;
      this.inputStart = null;
      this.inputEnd = null;
      this.startJam = null;
      this.finishJam = null;
      this.selectedJasa = null;
      this.availableStock = false;
      this.jasaItems = [];
      this.modalDetail(this.item_pemasukan[this.editedIndex]);
    },
    async onCekJadwal() {
      let d1 = new Date(
        this.inputStart + " " + this.startJam.replace(":01", ":00")
      );
      let d2 = new Date(this.inputEnd + " " + this.finishJam);
      let greaterThanDate = d1.getTime() > d2.getTime();

      if (!greaterThanDate) {
        this.availableStock = false;
        const resp = await this.getProductJasaHargaJual(
          this.selectedItem.harga_jual
        );
        this.jasaItems = [];
        let available = resp.data.attributes;
        if (
          this.inputStart &&
          this.inputEnd &&
          this.startJam &&
          this.finishJam &&
          this.inputStart + " " + this.startJam.replace(":01", ":00") !=
            this.inputEnd + " " + this.finishJam
        ) {
          const payload = {
            from: this.inputStart + " " + this.startJam,
            to: this.inputEnd + " " + this.finishJam,
          };
          const response = await this.cekJadwal(payload);

          forEach(response.data.attributes, (data) => {
            remove(available, function(currentObject) {
              return currentObject.id === data.product_id;
            });
          });

          forEach(available, (ava) => {
            this.jasaItems.push(ava);
          });
        }

        let tempFinishJam =
          this.finishJam == "23:59:00" ? "00:00:00" : this.finishJam;

        const start = new Date(this.inputStart + " " + this.startJam);
        let end = new Date(this.inputEnd + " " + tempFinishJam);
        if (this.finishJam == "23:59:00") {
          end.setDate(end.getDate() + 1);
        }

        if ((end - start + 1000) / 3600000 == Number(this.selectedItem.qty)) {
          this.availableStock = true;
        }
      } else {
        this.jasaItems = [];
      }
    },
    async AttachmentSave() {
      try {
        const data = new FormData();
        data.append("submission", this.fileAttachment);
        data.append("nama_submission", this.dataDetails.id);
        const response = await this.uploadSubmissionAttachment({ data: data });
        const dataRead = {
          type: "submission",
          type_id: this.dataDetails.id,
        };
        await this.deleteRead(dataRead);

        if (response.data.success) {
          this.$notify({
            group: "custom-notification",
            type: "success",
            title: "Success!",
            text: "Upload Attachment Berhasil!",
          });
          this.fileAttachment = null;
          this.AttachmentClose();
          this.allAttachment(this.dataDetails.id);
        }
      } catch (e) {
        console.log(e);
      }
    },
    AttachmentClose() {
      this.attachmentModalVisible = false;
      this.fileAttachment = null;
    },
    async handleDeleteSubmissionAttachment(id, index) {
      this.dataAttachment.splice(index, 1);
      await this.removeAttachmentSubmission(id);
      this.$notify({
        group: "custom-notification",
        type: "success",
        title: "Success!",
        text: "Sukses menghapus Attachment!",
      });
      // const dataRead = {
      //   type : 'submission',
      //   type_id : this.dataDetails.id
      // }
      // await this.deleteRead(dataRead)
    },

    editStatusFulfilled(item, status) {
      this.editedIndex = this.item_pemasukan.indexOf(item);
      if (status === "ACCEPT_FULFILLED") {
        this.dialogTextEditedFulfilled = "Apakah anda yakin ingin fulfilled?";
      } else {
        this.dialogTextEditedFulfilled =
          "Apakah anda yakin ingin tidak fulfilled?";
      }
      this.editedFulfilled = status === "ACCEPT_FULFILLED" ? 1 : 0;
      this.editedItem = Object.assign({}, item);
      this.dialogFulfilled = true;
    },
    async saveFulfilled() {
      try {
        let is_fulfilled;
        if (
          this.dialogTextEditedFulfilled == "Apakah anda yakin ingin fulfilled?"
        ) {
          is_fulfilled = 1;
        } else {
          is_fulfilled = 0;
        }
        let response = await this.createBulk({
          is_fulfilled: is_fulfilled,
          submission_ids: [this.editedItem.id],
          CategoriBulk: "Bulk Fulfillment",
          kategoriBulk: this.activeCategory.id,
        });

        if (response.data.success) {
          const dataPagination = {
            category_id: this.activeCategory.id,
            page: this.pageSizes,
            jum: this.pageSize,
          };
          const dataItem = await this.dataPemasukan(dataPagination);
          this.reloadData();
          this.bulkModalVisible = false;
        }
      } catch (e) {
        console.log(e);
      }

      // this.reloadData()
      this.closeFulfilled();
    },
    closeFulfilled() {
      this.editedIndex = -1;
      this.dialogFulfilled = false;
      this.closeDraft();
    },
    async onChangeCategory() {
      this.currentPage = 1;
      this.selected = [];
      this.activeCategory = find(
        this.submissionCategoryItems,
        (categoryItem) => categoryItem.id == this.activeCategory
      );
      this.subReload();

      const maksimumPending = await this.getMaksimumSubmissions();
      const maksPendingTemp = find(
        maksimumPending.data.attributes,
        (makpen) =>
          makpen.type == "PEMASUKAN" &&
          makpen.categories_name == this.activeCategory.name
      );
      if (maksPendingTemp && maksPendingTemp.jumlah_maksimum > 0) {
        this.maksPending = maksPendingTemp.jumlah_maksimum;
      }
      const totalPendings = countBy(
        this.item_pemasukan,
        (item) => item.status == "PENDING"
      ).true;
      this.totalPending = totalPendings == undefined ? 0 : totalPendings;
    },
    async searchUser() {
      this.userFound = false;
      this.newUser = false;
      const response = await this.getUsersByEmailOrPhone(this.inputSearch);
      if (response.data != "") {
        this.editedItemUser.id = response.data.id;
        this.editedItemUser.name = response.data.name;
        this.editedItemUser.email = response.data.email;
        this.editedItemUser.telp = response.data.telp;
        this.userFound = true;
      } else {
        this.editedItemUser.name = "";
        this.editedItemUser.email = "";
        this.editedItemUser.telp = "";
        this.newUser = true;
      }
      // console.log('response', response)
    },
    convertCurrency(total) {
      return "Rp. " + formatCurrency(total);
    },
    parseDate(date) {
      return dayjs(date).format("YYYY-MM-DDTHH:mm");
    },
    async onInputChange(query) {
      this.inputItem.item_name = "";
      if (query === null || query === "") {
        return "";
      }
      let filter = {
        type: "PEMASUKAN",
        q: query,
      };
      const results = await this.searchItem(filter);
      return results.data.attributes;
    },
    onSearchItemSelected(item) {
      console.log(item);
      this.searchQuery = item.item_name;
      this.inputItem.item_name = item.item_name;
      this.inputItem.harga_jual = Number(item.harga_jual);
      this.itemStart = item.schedule_start;
      this.itemFinish = item.schedule_finish;
      this.itemType = item.product_type;
      this.selectedSearchItem = item;
    },
    async initialize() {
      this.userLogin = JSON.parse(window.localStorage.getItem("user_data"));
      this.role = this.userLogin.roles[0].name;
      this.permission = this.userLogin.permissions;

      const dataItemCategories = await this.getSubmissionCategories();

      await forEach(dataItemCategories.data, (data) => {
        if (data.type == "PEMASUKAN") {
          this.submissionCategoryItems.push(data);
        }
      });

      if (this.$route.query.category != undefined) {
        this.activeCategory = find(
          this.submissionCategoryItems,
          (categoryItem) => categoryItem.name == this.$route.query.category
        );
      } else if (this.$route.query.category_id != undefined) {
        this.activeCategory = find(
          this.submissionCategoryItems,
          (categoryItem) => categoryItem.id == this.$route.query.category_id
        );
      } else {
        this.activeCategory = find(
          this.submissionCategoryItems,
          (categoryItem) => categoryItem.name == "ORDER"
        );
      }
      const dataPagination = {
        category_id: this.activeCategory.id,
        page: this.pageSizes,
        jum: this.pageSize,
      };
      const dataItem = await this.dataPemasukan(dataPagination);
      this.totalPemasukan = dataItem.total;
      const getRoles = await this.getRoles;
      for (let role of getRoles.data.attributes) {
        this.roles.push({
          name: role.name == "unverified" ? "Personal" : "Company",
          id: role.id,
        });
      }
      this.totalPages = dataItem.submission.last_page;
      this.currentPage = dataItem.submission.current_page;
      this.from = dataItem.submission.from;
      this.to = dataItem.submission.to;
      this.totalData = dataItem.submission.total;
      forEach(dataItem.submission.data, (data, index) => {
        forEach(data.items, (subItem, i) => {
          data.items[i].harga_jual = Number(subItem.harga_jual);
          data.items[i].qty = Number(subItem.qty);
          data.items[i].discount = Number(subItem.discount);
          data.items[i].ppn = Number(subItem.ppn);
        });
        data.total = Number(data.total);
        this.item_pemasukan.push(data);
      });
      const maksimumPending = await this.getMaksimumSubmissions();
      const maksPendingTemp = find(
        maksimumPending.data.attributes,
        (makpen) =>
          makpen.type == "PEMASUKAN" &&
          makpen.categories_name == this.activeCategory.name
      );
      if (maksPendingTemp && maksPendingTemp.jumlah_maksimum > 0) {
        this.maksPending = maksPendingTemp.jumlah_maksimum;
      }
      const totalPendings = countBy(
        this.item_pemasukan,
        (item) => item.status == "PENDING"
      ).true;
      this.totalPending = totalPendings == undefined ? 0 : totalPendings;

      const paymentMethodResponse = await this.getListPaymentMethods();

      this.paymentMethod = [];
      forEach(paymentMethodResponse.data.attributes, (payment, i) => {
        this.paymentMethod.push({
          text: payment.name,
          value: payment.id,
        });
      });

      for (let i = 0; i < 24; i++) {
        this.jamItemsStart.push({
          text: i.toString().length == 1 ? "0" + i + ":00" : i + ":00",
          value: i.toString().length == 1 ? "0" + i + ":00:01" : i + ":00:01",
        });

        this.jamItemsFinish.push({
          text: i.toString().length == 1 ? "0" + i + ":00" : i + ":00",
          value: i.toString().length == 1 ? "0" + i + ":00:00" : i + ":00:00",
        });
      }

      this.jamItemsFinish.push({
        text: "24:00",
        value: "23:59:00",
      });

      // console.log(this.dateNow)
    },
    async searchCustomerByName(value, self) {
      if (!value) {
        self.customerOptions = [];
        self.customer = "";
      }
      // if customer already requested
      if (self.loadingCustomer) {
        return;
      }

      const payload = {
        name: value,
      };
      try {
        let response = await this.getUserByName(payload);
        self.customerOptions = response.data;
      } catch (e) {
        self.error = "Unknown Error. Please check details and try again.";
        self.failed();
      }
    },

    openNewCustomer() {
      this.showFormNewCustomer = !this.showFormNewCustomer;
    },
    editItem(data) {
      forEach(data.items, (item) => {
        item.harga_jual = Number(item.harga_jual);
        item.qty = Number(item.qty);
        item.discount = Number(item.discount);
        item.ppn = Number(item.ppn);
      });
      console.log("data", data);
      this.items = data.items;
      this.editedIndex = this.item_pemasukan.indexOf(data);
      this.editedItem = Object.assign({}, data);
      this.editedItem.date = moment(this.editedItem.date).format(
        "YYYY-MM-DDTHH:mm"
      );
      this.editedItem.due_date = this.editedItem.due_date
        ? moment(this.editedItem.due_date).format("YYYY-MM-DDTHH:mm")
        : moment().format("YYYY-MM-DDTHH:mm");
      if (this.editedItem.customer) {
        this.editedItemUser.id = this.editedItem.customer.id;
        this.editedItemUser.name = this.editedItem.customer.name;
        this.editedItemUser.email = this.editedItem.customer.email;
        this.editedItemUser.telp = this.editedItem.customer.telp;
        this.userFound = true;
      }
      this.isSaved = true;
      this.dialog = true;
    },
    addItem() {
      this.items.push({
        product_id: 0,
        item_name:
          this.inputItem.item_name == ""
            ? this.searchQuery
            : this.inputItem.item_name,
        harga_jual: this.inputItem.harga_jual,
        discount: this.inputItem.discount ? this.inputItem.discount : 0,
        ppn: this.inputItem.ppn ? this.inputItem.ppn : 0,
        qty: this.inputItem.qty ? this.inputItem.qty : 0,
        start: this.itemType === "MANAGED_ALL" ? this.itemStart : null,
        finish: this.itemType === "MANAGED_ALL" ? this.itemFinish : null,
      });

      console.log("this.items", this.items);

      this.inputItem = {
        product_id: 0,
        item_name: "",
        harga_jual: "",
        discount: "",
        ppn: "",
        qty: "",
      };

      this.searchQuery = "";
      this.item_items = [];
      this.itemType = null;
    },
    removeItem(item) {
      if (this.items.length === 1) {
        return alert(
          "Tidak bisa menghapus item tunggal pada penawaran pemasukan"
        );
      }
      const index = this.items.indexOf(item);
      this.items.splice(index, 1);
    },

    onClickPrint(item) {
      window.open("/print/" + item.id, "_blank");
    },
    async allAttachment(id) {
      const responseAttachment = await this.getAttachmentSubmission(id);
      this.dataAttachment = responseAttachment.data.attributes;
    },

    async modalDetail(item) {
      this.paid = 0;
      this.editedIndex = this.item_pemasukan.indexOf(item);
      const response = await this.getUserById(item.user_id);
      const responsePayment = await this.getTransaction(item.id);
      this.setSubmissionId(item.id);
      this.allAttachment(item.id);

      const responseSubmissionNote = await this.getSubmissionNote;
      this.submissionNotes = responseSubmissionNote;
      this.dataUserInvoice = Object.assign({}, response.data.attributes);
      this.paymentItems = isEmpty(responsePayment.data.attributes)
        ? null
        : Object.assign({}, responsePayment.data.attributes);
      if (this.paymentItems != null) {
        forEach(this.paymentItems, (paymentItem) => {
          this.paid += Number(paymentItem.jumlah);
        });
      }

      let responseDetail = await this.getPemasukanByIdPOS(item.id);
      this.dataDetails = responseDetail.data[0];
      const data = {
        type: "submission",
        type_id: item.id,
      };
      await this.storeRead(data);
      this.dialog2 = true;
      this.editDueDate = this.parseDate(responseDetail.data[0].due_date);
    },
    async closeInvoice() {
      this.dialog2 = false;
      this.expand = false;
      this.editedIndex = -1;

      this.reloadData();
    },
    async changeRead(item) {
      // console.log(item)
      if (item.alreadyread.user_id != this.userLogin.id) {
        const data = {
          type_id: item.id,
          type: "submission",
        };
        await this.storeRead(data);
      }
      // else{
      //   const data = {
      //     type_id : item.id,
      //     type : 'submission',
      //   }
      //   await this.deletePerson(data)
      // }
      this.reloadData();
    },

    async reloadData() {
      this.item_pemasukan = [];
      let payload = {
        metode: this.metodeFilter,
        page: this.currentPage,
        jum: this.pageSize,
        search: this.search,
      };
      let dataItem = {};

      if (this.selectedStatus) {
        payload.condition = {
          status: this.selectedStatus,
          category_id: this.activeCategory.id,
          type: "PEMASUKAN",
        };
      } else {
        payload.condition = {
          category_id: this.activeCategory.id,
          type: "PEMASUKAN",
        };
      }
      if (this.fromDateFilter && this.toDateFilter) {
        payload.between = {
          from: dayjs(this.fromDateFilter)
            .add(59, "second")
            .format("YYYY-MM-DDTHH:mm:ss"),
          to: dayjs(this.toDateFilter)
            .add(59, "second")
            .format("YYYY-MM-DDTHH:mm:ss"),
        };
      }
      if (payload.between || this.selectedStatus || this.search) {
        // console.log(payload)
        const response = await this.filterPemasukan(payload);
        dataItem = response.data;
      } else {
        const dataPaginate = {
          category_id: this.activeCategory.id,
          page: this.currentPage,
          jum: this.pageSize,
        };
        dataItem = await this.dataPemasukan(dataPaginate);
      }
      this.totalPages = dataItem.submission.last_page;
      this.currentPage = dataItem.submission.current_page;
      this.from = dataItem.submission.from;
      this.to = dataItem.submission.to;
      this.totalData = dataItem.submission.total;
      forEach(dataItem.submission.data, (data, index) => {
        forEach(data.items, (subItem, i) => {
          data.items[i].harga_jual = Number(subItem.harga_jual);
          data.items[i].qty = Number(subItem.qty);
          data.items[i].discount = Number(subItem.discount);
          data.items[i].ppn = Number(subItem.ppn);
        });
        this.item_pemasukan.push(data);
      });
    },
    async resetFilter() {
      this.search = null;
      this.selectedStatus = null;
      this.showFilteredTitle = false;
      this.filterModalVisible = false;
      this.showCompareButton = false;
      this.showCompareTable = false;
      this.toDateFilter = null;
      this.fromDateFilter = null;
      this.pageSizes = [10, 50, 100];
      this.currentPage = 1;
      this.totalPages = 0;
      this.pageSize = 10;
      this.from = 0;
      this.to = 0;
      this.totalData = 0;
      this.item_pemasukan = [];
      const dataPaginate = {
        category_id: this.activeCategory.id,
        page: this.currentPage,
        jum: this.pageSize,
      };
      const dataItem = await this.dataPemasukan(dataPaginate);
      this.totalPemasukan = dataItem.total;
      this.totalPages = dataItem.submission.last_page;
      this.currentPage = dataItem.submission.current_page;
      this.from = dataItem.submission.from;
      this.to = dataItem.submission.to;
      this.totalData = dataItem.submission.total;
      forEach(dataItem.submission.data, (data, index) => {
        forEach(data.items, (subItem, i) => {
          data.items[i].harga_jual = Number(subItem.harga_jual);
          data.items[i].qty = Number(subItem.qty);
          data.items[i].discount = Number(subItem.discount);
          data.items[i].ppn = Number(subItem.ppn);
        });
        this.item_pemasukan.push(data);
      });
    },

    async completeSubmission() {
      const payloadUpdate = {
        id: this.dataDetails.id,
        status: "COMPLETED",
        data: this.dataDetails,
      };

      const responseUpdate = await this.updateStatusPemasukan(payloadUpdate);
      if (responseUpdate.data.success) {
        this.dataDetails.status = "COMPLETED";
        this.item_pemasukan[this.editedIndex].status = "COMPLETED";
        this.$notify({
          group: "custom-notification",
          type: "success",
          title: "Success!",
          text: "Invoice telah selesai",
        });
      }
    },

    async backToPaid() {
      const payloadUpdate = {
        id: this.dataDetails.id,
        status: "PAID",
        data: this.dataDetails,
      };

      const responseUpdate = await this.updateStatusPemasukan(payloadUpdate);
      if (responseUpdate.data.success) {
        this.dataDetails.status = "PAID";
        this.item_pemasukan[this.editedIndex].status = "PAID";
        this.$notify({
          group: "custom-notification",
          type: "warning",
          title: "Success!",
          text: "Invoice complete canceled",
        });
      }
    },

    async deletePayment(item) {
      if (Number(this.paid) - Number(item.jumlah) < 1) {
        const payloadUpdate = {
          id: this.dataDetails.id,
          status: "APPROVED",
          data: this.dataDetails,
        };
        const responseUpdate = await this.updateStatusPemasukan(payloadUpdate);
        if (responseUpdate.data.success) {
          this.dataDetails.status = "APPROVED";
          this.item_pemasukan[this.editedIndex].status = "APPROVED";
          this.$notify({
            group: "custom-notification",
            type: "success",
            title: "Success!",
            text: "Success update pemasukan",
          });
        }
      } else {
        const payloadUpdate = {
          id: this.dataDetails.id,
          status: "PARTIAL",
          data: this.dataDetails,
        };
        const responseUpdate = await this.updateStatusPemasukan(payloadUpdate);
        if (responseUpdate.data.success) {
          this.dataDetails.status = "PARTIAL";
          this.item_pemasukan[this.editedIndex].status = "PARTIAL";
          this.$notify({
            group: "custom-notification",
            type: "success",
            title: "Success!",
            text: "Success update pemasukan",
          });
        }
      }

      const response = await this.deleteTransaction(item.id);
      if (response.data.success) {
        const responsePayment = await this.getTransaction(this.dataDetails.id);
        this.paymentItems = isEmpty(responsePayment.data.attributes)
          ? null
          : Object.assign({}, responsePayment.data.attributes);
        if (this.paymentItems != null) {
          this.paid = 0;
          forEach(this.paymentItems, (paymentItem) => {
            this.paid += Number(paymentItem.jumlah);
          });
        } else {
          this.paid = 0;
        }

        this.$notify({
          group: "custom-notification",
          type: "success",
          title: "Success!",
          text: "Data pembayaran berhasil dihapus",
        });
      } else {
        alert("Network Error!");
      }
    },

    editStatusApprove(item) {
      this.note = item.note;
      this.approval = "Persetujuan";
      this.editedIndex = this.item_pemasukan.indexOf(item);
      this.editedItem = Object.assign({}, { ...item });
      if (this.role == "admin") {
        this.note = item.note;
        this.saveApproval(this.approval);
      } else {
        this.dialogApproval = true;
      }
    },

    editStatusRefuse(item) {
      this.note = item.note;
      this.approval = "Penolakan";
      this.editedIndex = this.item_pemasukan.indexOf(item);
      this.editedItem = Object.assign({}, item);

      if (this.role == "admin") {
        this.note = item.note;
        this.saveApproval(this.approval);
      } else {
        this.dialogApproval = true;
      }
    },

    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }

      return new File([u8arr], filename, { type: mime });
    },

    async savePayment() {
      if (this.jumlahPayment <= Number(this.dataDetails.total) - this.paid) {
        const data = new FormData();
        data.append("submission_id", this.dataDetails.id);
        data.append("payment_method_id", this.paymentMethodSelected);
        data.append("tanggal", this.paymentDate);
        data.append("jumlah", this.jumlahPayment);
        if(this.takeCamera && this.img){
          data.append("transaction", this.dataURLtoFile(this.img, Date.now().toString()+".jpg"));
        }else{
          data.append("transaction", this.fileAttachmentPayment);
        }

        const response = await this.createTransaction({ data: data });

        if (response.data.success) {
          if (
            this.dataDetails.total ==
            Number(this.paid) + Number(this.jumlahPayment)
          ) {
            const payloadUpdate = {
              id: this.dataDetails.id,
              status: "PAID",
              data: this.dataDetails,
            };
            const responseUpdate = await this.updateStatusPemasukan(
              payloadUpdate
            );
            if (responseUpdate.data.success) {
              this.dataDetails.status = "PAID";
              this.item_pemasukan[this.editedIndex].status = "PAID";
              this.$notify({
                group: "custom-notification",
                type: "success",
                title: "Success!",
                text: "Pembayaran telah dilunasi",
              });
            }
          } else {
            const payloadUpdate = {
              id: this.dataDetails.id,
              status: "PARTIAL",
              data: this.dataDetails,
            };

            const responseUpdate = await this.updateStatusPemasukan(
              payloadUpdate
            );
            if (responseUpdate.data.success) {
              this.dataDetails.status = "PARTIAL";
              this.item_pemasukan[this.editedIndex].status = "PARTIAL";
              this.$notify({
                group: "custom-notification",
                type: "success",
                title: "Success!",
                text: "Sebagian pembayaran telah dilunasi",
              });
            }
          }
          const responsePayment = await this.getTransaction(
            this.dataDetails.id
          );
          this.paymentItems = isEmpty(responsePayment.data.attributes)
            ? null
            : Object.assign({}, responsePayment.data.attributes);
          if (this.paymentItems != null) {
            this.paid = 0;
            forEach(this.paymentItems, (paymentItem) => {
              this.paid += Number(paymentItem.jumlah);
            });
          }

          this.paymentMethodSelected = "";
          this.paymentDate = "";
          this.jumlahPayment = 0;
          this.closePayment();
          this.$notify({
            group: "custom-notification",
            type: "success",
            title: "Success!",
            text: "Data pembayaran berhasil disimpan",
          });
        } else {
          alert("Network Error!");
        }
      } else {
        this.showError = true;
      }
    },

    closePayment() {
      if(this.$refs.webcam != undefined){
        this.onStop()
      }
      this.takeCamera = false;
      this.img = null;
      this.camera = null;
      this.deviceId = null;
      this.devices = [];
      this.showError = false;
      this.dialog3 = false;
      this.fileAttachmentPayment = null;
    },

    async saveApproval(status) {
      try {
        let statusParam = "";
        let message = "";
        if (status == "Persetujuan" && this.role === "admin") {
          statusParam = "APPROVED";
          message = "Pemasukan berhasil disetujui";
        } else if (status == "Persetujuan" && this.role === "accountant") {
          statusParam = "PARTIAL APPROVED";
          message = "Pemasukan berhasil disetujui";
        } else {
          statusParam = "REJECTED";
          message = "Pemasukan berhasil ditolak";
        }
        this.editedItem.status = statusParam;
        this.editedItem.note = this.note;

        const response = await this.updatePemasukan(this.editedItem);
        this.editedItem.total = Number(this.editedItem.total);
        response.data.attributes[0].total = Number(
          response.data.attributes[0].total
        );
        forEach(response.data.attributes[0].items, (item) => {
          item.harga_jual = Number(item.harga_jual);
          item.qty = Number(item.qty);
          item.discount = Number(item.discount);
          item.ppn = Number(item.ppn);
        });
        Object.assign(
          this.item_pemasukan[this.editedIndex],
          response.data.attributes[0]
        );
        this.$notify({
          group: "custom-notification",
          type: "success",
          title: "Success!",
          text: message,
        });
      } catch (e) {
        console.log(e);
      }
      this.reloadData();
      this.closeApproval();
    },

    closeApproval() {
      this.note = "";
      this.dialogApproval = false;
      this.editedIndex = -1;
    },

    async saveNote() {
      try {
        const payloadUpdate = {
          id: this.editedItem.id,
          status: this.editedItem.status,
          data: this.editedItem,
        };
        this.editedItem.note = this.note;
        const responseUpdate = await this.updateStatusPemasukan(payloadUpdate);
        if (responseUpdate.data.success) {
          this.item_pemasukan[this.editedIndex].note = this.note;
          this.$notify({
            group: "custom-notification",
            type: "success",
            title: "Success!",
            text: "Success update catatan",
          });
        }
      } catch (e) {
        console.log(e);
      }
      this.closeNote();
    },

    closeNote() {
      this.note = "";
      this.dialogEditNote = false;
      this.editedIndex = -1;
    },

    noteModal(item) {
      this.note = item.note;
      this.dialogNote = true;
    },

    modalEditNote(item) {
      this.note = item.note;
      if (item.status == "APPROVED") {
        this.approval = "Persetujuan";
      } else {
        this.approval = "Penolakan";
      }
      this.editedIndex = this.item_pemasukan.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogEditNote = true;
    },

    async deleteItemDraft(item) {
      const index = this.item_pemasukan.indexOf(item);
      if (confirm("Apakah anda yakin menghapus data pemasukan ini?")) {
        await this.deletePemasukan(item.id);
        this.item_pemasukan.splice(index, 1);
        this.$notify({
          group: "custom-notification",
          type: "success",
          title: "Success!",
          text: "Pemasukan berhasil dihapus",
        });
      }
    },

    async close() {
      let last = 0;
      const isEmpty = !Object.values(this.editedItem).some(
        (x) => x !== null && x !== ""
      );
      if (!isEmpty && !this.isSaved) {
        let total = 0;
        forEach(this.items, (item) => {
          if (
            item.discount != "" &&
            item.ppn != "" &&
            item.discount != 0 &&
            item.ppn != 0
          ) {
            total =
              total +
              Number(item.qty) *
                Number(item.harga_jual) *
                (1 - Number(item.discount) / 100) *
                (1 + Number(item.ppn) / 100);
          } else if (item.discount != "" && item.discount != 0) {
            total =
              total +
              Number(item.qty) *
                Number(item.harga_jual) *
                (1 - Number(item.discount) / 100);
          } else if (item.ppn != "" && item.ppn != 0) {
            total =
              total +
              Number(item.qty) *
                Number(item.harga_jual) *
                (1 + Number(item.ppn) / 100);
          } else {
            total = total + Number(item.qty) * Number(item.harga_jual);
          }

          item.ppn = item.ppn == "" ? 0 : item.ppn;
          item.discount = item.discount == "" ? 0 : item.discount;
        });

        let partner_id;
        if (this.newUser) {
          this.editedItemUser.username = this.editedItemUser.name
            .toLowerCase()
            .replace(/\s/g, "");
          this.editedItemUser.password =
            new Date().getTime().toString() +
            Math.floor(Math.random() * 10000000 + 1).toString();
          let responseUser = await this.createUserSubmission(
            this.editedItemUser
          );
          if (responseUser.data.success) {
            this.$notify({
              group: "custom-notification",
              type: "success",
              title: "Success!",
              text: "Berhasil Membuat customer Baru",
            });
            partner_id = responseUser.data.attributes.user.id;
          } else {
            return;
          }
        } else if (this.userFound) {
          partner_id = this.editedItemUser.id;
        } else {
          partner_id = this.userLogin.id;
        }
        this.editedItem.partner_id = partner_id;

        const itemDraft = {
          ...this.editedItem,
          id: last + 1,
          total,
          items: this.items,
          category_id: this.activeCategory.id,
          status: "DRAFT",
          type: "PEMASUKAN",
          date: dayjs().format("YYYY-MM-DDTHH:mm"),
        };

        const response = await this.createPemasukan(itemDraft);
        const last_id =
          response.data.attributes && response.data.attributes.length
            ? response.data.attributes[0].id
            : last;
        itemDraft.id = last_id;
        if (response.data.attributes && response.data.attributes.length)
          this.item_pemasukan.push(response.data.attributes[0]);
        this.$notify({
          group: "custom-notification",
          type: "warning",
          title: "Success!",
          text: "Tersimpan sebagai draft",
        });
      }

      this.items = [];
      this.item_pemasukan = orderBy(
        this.item_pemasukan,
        ["id", "status"],
        ["desc", "DRAFT"]
      );
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
      this.dialog = false;
      this.userFound = false;
      this.newUser = false;
      this.editedItemUser = Object.assign({}, this.defaultItemUser);
      this.inputSearch = "";
    },
    closeDraft() {
      this.items = [];
      this.item_pemasukan = orderBy(
        this.item_pemasukan,
        ["id", "status"],
        ["desc", "DRAFT"]
      );
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
      this.dialog = false;
      this.userFound = false;
      this.newUser = false;
      this.editedItemUser = Object.assign({}, this.defaultItemUser);
      this.inputSearch = "";
    },
    async save() {
      let total = 0;
      forEach(this.items, (item) => {
        item.ppn = item.ppn == "" ? 0 : item.ppn;

        if (!this.newUser && !this.userFound) {
          item.discount = 100;
        } else if (this.userFound) {
          if (this.editedItemUser.id == this.userLogin.id) {
            item.discount = 100;
          } else {
            item.discount = item.discount == "" ? 0 : item.discount;
          }
        } else {
          item.discount = item.discount == "" ? 0 : item.discount;
        }

        if (
          item.discount != "" &&
          item.ppn != "" &&
          item.discount != 0 &&
          item.ppn != 0
        ) {
          total =
            total +
            Number(item.qty) *
              Number(item.harga_jual) *
              (1 - Number(item.discount) / 100) *
              (1 + Number(item.ppn) / 100);
        } else if (item.discount != "" && item.discount != 0) {
          total =
            total +
            Number(item.qty) *
              Number(item.harga_jual) *
              (1 - Number(item.discount) / 100);
        } else if (item.ppn != "" && item.ppn != 0) {
          total =
            total +
            Number(item.qty) *
              Number(item.harga_jual) *
              (1 + Number(item.ppn) / 100);
        } else {
          total = total + Number(item.qty) * Number(item.harga_jual);
        }
      });
      this.editedItem.total = total;
      if (this.editedItem.due_date < this.editedItem.date) {
        return this.$notify({
          group: "custom-notification",
          type: "error",
          title: "Error!",
          text: "Batas waktu tidak boleh lebih kecil daripada tanggal",
        });
      }
      this.editedItem.date = dayjs(this.editedItem.date).format(
        "YYYY-MM-DDTHH:mm"
      );
      this.editedItem.due_date = dayjs(this.editedItem.due_date).format(
        "YYYY-MM-DDTHH:mm"
      );
      if (this.editedIndex > -1) {
        try {
          let partner_id;
          if (this.newUser) {
            this.editedItemUser.username = this.editedItemUser.name
              .toLowerCase()
              .replace(/\s/g, "");
            this.editedItemUser.password =
              new Date().getTime().toString() +
              Math.floor(Math.random() * 10000000 + 1).toString();
            let responseUser = await this.createUserSubmission(
              this.editedItemUser
            );
            if (responseUser.data.success) {
              this.$notify({
                group: "custom-notification",
                type: "success",
                title: "Success!",
                text: "Berhasil Membuat customer Baru",
              });
              partner_id = responseUser.data.attributes.user.id;
            } else {
              return;
            }
          } else if (this.userFound) {
            partner_id = this.editedItemUser.id;
          } else {
            partner_id = this.userLogin.id;
          }
          this.editedItem.partner_id = partner_id;
          this.editedItem.items = this.items;
          this.editedItem.note = null;
          if (
            this.editedItem.status == "DRAFT" &&
            this.editedItem.items.length > 0
          ) {
            this.editedItem.status = "PENDING";
          }
          const response = await this.updatePemasukan(this.editedItem);
          this.editedItem.total = Number(this.editedItem.total);
          response.data.attributes[0].total = Number(
            response.data.attributes[0].total
          );
          forEach(response.data.attributes[0].items, (item) => {
            item.harga_jual = Number(item.harga_jual);
            item.qty = Number(item.qty);
            item.discount = Number(item.discount);
            item.ppn = Number(item.ppn);
          });
          Object.assign(
            this.item_pemasukan[this.editedIndex],
            response.data.attributes[0]
          );
          // const newTotalPemasukan = this.item_pemasukan.reduce((acc,pemasukan) => {
          //   return acc + pemasukan.total
          // },0)
          // this.totalPemasukan = newTotalPemasukan
          this.activeCategory = this.editedItem.category_id;
          this.onChangeCategory();
          this.$notify({
            group: "custom-notification",
            type: "success",
            title: "Success!",
            text: "Success update pemasukan " + this.editedItem.name,
          });
        } catch (e) {
          console.log(e);
        }
      } else {
        let partner_id;
        if (this.newUser) {
          this.editedItemUser.username = this.editedItemUser.name
            .toLowerCase()
            .replace(/\s/g, "");
          this.editedItemUser.password =
            new Date().getTime().toString() +
            Math.floor(Math.random() * 10000000 + 1).toString();
          let responseUser = await this.createUserSubmission(
            this.editedItemUser
          );
          if (responseUser.data.success) {
            this.$notify({
              group: "custom-notification",
              type: "success",
              title: "Success!",
              text: "Berhasil Membuat customer Baru",
            });
            partner_id = responseUser.data.attributes.user.id;
          } else {
            return;
          }
        } else if (this.userFound) {
          partner_id = this.editedItemUser.id;
        } else {
          partner_id = this.userLogin.id;
        }

        this.editedItem.partner_id = partner_id;
        this.editedItem.category_id = this.activeCategory.id;
        this.editedItem.items = this.items;
        let response = "";
        try {
          response = await this.createPemasukan(this.editedItem);
        } catch (e) {
          console.log(e);
        }

        this.editedItem.total = Number(response.data.attributes[0].total);
        this.editedItem.date = response.data.attributes[0].date;
        this.editedItem.status = response.data.attributes[0].status;
        response.data.attributes[0].total = Number(
          response.data.attributes[0].total
        );
        forEach(response.data.attributes[0].items, (item) => {
          item.harga_jual = Number(item.harga_jual);
          item.qty = Number(item.qty);
          item.discount = Number(item.discount);
          item.ppn = Number(item.ppn);
        });
        this.item_pemasukan.splice(0, 0, response.data.attributes[0]);
        this.$notify({
          group: "custom-notification",
          type: "success",
          title: "Success!",
          text: "Success create pemasukan " + this.editedItem.name,
        });
      }
      this.isSaved = true;
      this.close();
    },
    editableSave() {
      this.snack = true;
      this.snackColor = "success";
      this.snackText = "Data saved";
    },
    editableCancel() {
      // this.snack = true;
      // this.snackColor = "error";
      // this.snackText = "Canceled";
    },
    editableOpen() {
      // this.snack = true;
      // this.snackColor = "info";
      // this.snackText = "Dialog edit opened";
    },
    editableClose() {
      // console.log("Dialog closed");
    },
    submissionNoteClose() {
      this.noteModalVisible = false;
    },
    async submissionNoteSave() {
      const payload = {
        submission_id: this.dataDetails.id,
        comment: this.newNote.comment,
        date: this.newNote.date,
      };
      try {
        const response = await this.createSubmissionNote({
          ...payload,
        });
        this.$notify({
          group: "custom-notification",
          type: "success",
          title: "Success!",
          text: "Sukses menambahkan catatan!",
        });
        this.submissionNotes.push({
          ...response.data.attributes,
          user: this.userLogin,
        });
        this.noteModalVisible = false;
      } catch (e) {
        console.log(e);
      }
    },
    async handleDeleteSubmissionNote(id, index) {
      this.submissionNotes.splice(index, 1);
      try {
        await this.deleteSubmissionNote(id);
        this.$notify({
          group: "custom-notification",
          type: "success",
          title: "Success!",
          text: "Sukses menghapus catatan!",
        });
      } catch (e) {
        console.log(e);
      }
    },
    async handleFilterByStatus(table) {
      const conditionalTable = {
        FILTER: {
          item_pemasukan: "item_pemasukan",
          totalPemasukan: "totalPemasukan",
          fromDate: this.fromDateFilter,
          toDate: this.toDateFilter,
        },
        COMPARE: {
          item_pemasukan: "item_pemasukan_compared",
          totalPemasukan: "totalPemasukanCompared",
          fromDate: this.fromDateCompare,
          toDate: this.toDateCompare,
        },
      };
      let payload = {
        metode: this.metodeFilter,
        page: 1,
        jum: this.pageSize,
        search: this.search,
      };
      if (this.selectedStatus) {
        payload.condition = {
          status: this.selectedStatus,
          category_id: this.activeCategory.id,
          type: "PEMASUKAN",
        };
      } else {
        payload.condition = {
          category_id: this.activeCategory.id,
          type: "PEMASUKAN",
        };
      }
      if (
        conditionalTable[table]["fromDate"] &&
        conditionalTable[table]["toDate"]
      ) {
        payload.between = {
          from: conditionalTable[table]["fromDate"],
          to: conditionalTable[table]["toDate"],
        };
      }
      let dataItem = await this.filterPemasukan(payload);
      this[conditionalTable[table]["item_pemasukan"]] = [];
      this[conditionalTable[table]["totalPemasukan"]] = dataItem.data.total;
      this.totalPages = dataItem.data.submission.last_page;
      this.currentPage = dataItem.data.submission.current_page;
      this.from = dataItem.data.submission.from;
      this.to = dataItem.data.submission.to;
      this.totalData = dataItem.data.submission.total;
      forEach(dataItem.data.submission.data, (data, index) => {
        forEach(data.items, (subItem, i) => {
          data.items[i].harga_jual = Number(subItem.harga_jual);
          data.items[i].qty = Number(subItem.qty);
          data.items[i].discount = Number(subItem.discount);
          data.items[i].ppn = Number(subItem.ppn);
        });
        this[conditionalTable[table]["item_pemasukan"]].push(data);
      });
      this.filterStatusModalVisible = false;
    },

    clearFilterStatus() {
      this.selectedStatus = null;
    },
    async subReload() {
      this.item_pemasukan = [];
      let payload = {
        metode: this.metodeFilter,
        page: 1,
        jum: this.pageSize,
        search: this.search,
      };
      let dataItem = {};

      if (this.selectedStatus) {
        payload.condition = {
          status: this.selectedStatus,
          category_id: this.activeCategory.id,
          type: "PEMASUKAN",
        };
      } else {
        payload.condition = {
          category_id: this.activeCategory.id,
          type: "PEMASUKAN",
        };
      }
      if (this.fromDateFilter && this.toDateFilter) {
        payload.between = {
          from: dayjs(this.fromDateFilter)
            .add(59, "second")
            .format("YYYY-MM-DDTHH:mm:ss"),
          to: dayjs(this.toDateFilter)
            .add(59, "second")
            .format("YYYY-MM-DDTHH:mm:ss"),
        };
      }
      if (payload.between || this.selectedStatus || this.search) {
        // console.log(payload)
        const response = await this.filterPemasukan(payload);
        dataItem = response.data;
      } else {
        const dataPaginate = {
          category_id: this.activeCategory.id,
          page: this.currentPage,
          jum: this.pageSize,
        };
        dataItem = await this.dataPemasukan(dataPaginate);
      }
      this.totalPemasukan = dataItem.total;
      this.totalPages = dataItem.submission.last_page;
      this.currentPage = dataItem.submission.current_page;
      this.from = dataItem.submission.from;
      this.to = dataItem.submission.to;
      this.totalData = dataItem.submission.total;
      forEach(dataItem.submission.data, (data, index) => {
        forEach(data.items, (subItem, i) => {
          data.items[i].harga_jual = Number(subItem.harga_jual);
          data.items[i].qty = Number(subItem.qty);
          data.items[i].discount = Number(subItem.discount);
          data.items[i].ppn = Number(subItem.ppn);
        });
        this.item_pemasukan.push(data);
      });
    },
    async resetSearch() {
      this.search = null;
      this.subReload();
    },
    async handleSearch() {
      let payload = {
        metode: this.metodeFilter,
        page: 1,
        jum: this.pageSize,
        search: this.search,
      };
      this.item_pemasukan = [];
      let dataItem = {};

      if (this.selectedStatus) {
        payload.condition = {
          status: this.selectedStatus,
          category_id: this.activeCategory.id,
          type: "PEMASUKAN",
        };
      } else {
        payload.condition = {
          category_id: this.activeCategory.id,
          type: "PEMASUKAN",
        };
      }
      if (this.fromDateFilter && this.toDateFilter) {
        payload.between = {
          from: dayjs(this.fromDateFilter)
            .add(59, "second")
            .format("YYYY-MM-DDTHH:mm:ss"),
          to: dayjs(this.toDateFilter)
            .add(59, "second")
            .format("YYYY-MM-DDTHH:mm:ss"),
        };
      }

      dataItem = await this.filterPemasukan(payload);

      this.totalPemasukan = dataItem.data.total;
      this.totalPages = dataItem.data.submission.last_page;
      this.currentPage = dataItem.data.submission.current_page;
      this.from = dataItem.data.submission.from;
      this.to = dataItem.data.submission.to;
      this.totalData = dataItem.data.submission.total;
      forEach(dataItem.data.submission.data, (data, index) => {
        forEach(data.items, (subItem, i) => {
          data.items[i].harga_jual = Number(subItem.harga_jual);
          data.items[i].qty = Number(subItem.qty);
          data.items[i].discount = Number(subItem.discount);
          data.items[i].ppn = Number(subItem.ppn);
        });
        this.item_pemasukan.push(data);
      });
    },
    async handleFilterByDate() {
      if (
        !dayjs(this.fromDateFilter).isValid() ||
        !dayjs(this.toDateFilter).isValid()
      ) {
        return this.$notify({
          group: "custom-notification",
          type: "error",
          title: "Error!",
          text: "Format tanggal salah!",
        });
      }
      if (this.fromDateFilter > this.toDateFilter) {
        return this.$notify({
          group: "custom-notification",
          type: "error",
          title: "Error!",
          text: "Dari tanggal tidak boleh lebih besar!",
        });
      }
      this.item_pemasukan = [];
      let payload = {
        metode: this.metodeFilter,
        page: 1,
        jum: this.pageSize,
        search: this.search,
      };
      let dataItem = {};

      if (this.selectedStatus) {
        payload.condition = {
          status: this.selectedStatus,
          category_id: this.activeCategory.id,
          type: "PEMASUKAN",
        };
      } else {
        payload.condition = {
          category_id: this.activeCategory.id,
          type: "PEMASUKAN",
        };
      }
      if (this.fromDateFilter && this.toDateFilter) {
        payload.between = {
          from: dayjs(this.fromDateFilter)
            .add(59, "second")
            .format("YYYY-MM-DDTHH:mm:ss"),
          to: dayjs(this.toDateFilter)
            .add(59, "second")
            .format("YYYY-MM-DDTHH:mm:ss"),
        };
      }

      dataItem = await this.filterPemasukan(payload);

      this.totalPemasukan = dataItem.data.total;
      this.totalPages = dataItem.data.submission.last_page;
      this.currentPage = dataItem.data.submission.current_page;
      this.from = dataItem.data.submission.from;
      this.to = dataItem.data.submission.to;
      this.totalData = dataItem.data.submission.total;
      forEach(dataItem.data.submission.data, (data, index) => {
        forEach(data.items, (subItem, i) => {
          data.items[i].harga_jual = Number(subItem.harga_jual);
          data.items[i].qty = Number(subItem.qty);
          data.items[i].discount = Number(subItem.discount);
          data.items[i].ppn = Number(subItem.ppn);
        });
        this.item_pemasukan.push(data);
      });
      this.showCompareButton = true;
      this.filterModalVisible = false;
      this.showFilteredTitle = true;
    },
    async handleCompareByDate() {
      if (
        !dayjs(this.fromDateCompare).isValid() ||
        !dayjs(this.toDateCompare).isValid()
      ) {
        return this.$notify({
          group: "custom-notification",
          type: "error",
          title: "Error!",
          text: "Format tanggal salah!",
        });
      }
      if (this.fromDateCompare > this.toDateCompare) {
        return this.$notify({
          group: "custom-notification",
          type: "error",
          title: "Error!",
          text: "Dari tanggal tidak boleh lebih besar!",
        });
      }

      this.item_pemasukan_compared = [];
      let dataItem = {};
      let payload = {
        metode: this.metodeCompare,
        page: 1,
        jum: this.pageSize,
      };

      if (this.selectedStatus) {
        payload.condition = {
          status: this.selectedStatus,
          category_id: this.activeCategory.id,
          type: "PEMASUKAN",
        };
      } else {
        payload.condition = {
          category_id: this.activeCategory.id,
          type: "PEMASUKAN",
        };
      }
      if (this.fromDateCompare && this.toDateCompare) {
        payload.between = {
          from: dayjs(this.fromDateCompare).format("YYYY-MM-DDTHH:mm"),
          to: dayjs(this.toDateFilter).format("YYYY-MM-DDTHH:mm"),
        };
      }

      dataItem = await this.filterPemasukan(payload);

      this.totalPemasukanCompared = dataItem.data.total;
      this.totalPages = dataItem.data.submission.last_page;
      this.currentPage = dataItem.data.submission.current_page;
      this.from = dataItem.data.submission.from;
      this.to = dataItem.data.submission.to;
      this.totalData = dataItem.data.submission.total;
      forEach(dataItem.data.submission.data, (data, index) => {
        forEach(data.items, (subItem, i) => {
          data.items[i].harga_jual = Number(subItem.harga_jual);
          data.items[i].qty = Number(subItem.qty);
          data.items[i].discount = Number(subItem.discount);
          data.items[i].ppn = Number(subItem.ppn);
        });
        this.item_pemasukan_compared.push(data);
      });
      this.showCompareTable = true;
      this.compareModalVisible = false;
      this.scrollToBottom();
    },
    scrollToBottom() {
      let element = document.getElementById("compareTable");
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "end" });
      }
    },
    async handlePageChange(value) {
      this.item_pemasukan = [];
      this.currentPage = value;
      let dataItem = {};
      let payload = {
        metode: this.metodeFilter,
        page: this.currentPage,
        jum: this.pageSize,
        search: this.search,
      };

      if (this.selectedStatus) {
        payload.condition = {
          status: this.selectedStatus,
          category_id: this.activeCategory.id,
          type: "PEMASUKAN",
        };
      } else {
        payload.condition = {
          category_id: this.activeCategory.id,
          type: "PEMASUKAN",
        };
      }
      if (this.fromDateFilter && this.toDateFilter) {
        payload.between = {
          from: dayjs(this.fromDateFilter)
            .add(59, "second")
            .format("YYYY-MM-DDTHH:mm:ss"),
          to: dayjs(this.toDateFilter)
            .add(59, "second")
            .format("YYYY-MM-DDTHH:mm:ss"),
        };
      }
      if (payload.between || this.selectedStatus || this.search) {
        const response = await this.filterPemasukan(payload);
        dataItem = response.data;
      } else {
        const dataPagination = {
          category_id: this.activeCategory.id,
          page: value,
          jum: this.pageSize,
        };
        dataItem = await this.dataPemasukan(dataPagination);
      }
      // console.log(dataItem)
      this.totalPages = dataItem.submission.last_page;
      this.currentPage = dataItem.submission.current_page;
      this.from = dataItem.submission.from;
      this.to = dataItem.submission.to;
      this.totalData = dataItem.submission.total;
      forEach(dataItem.submission.data, (data, index) => {
        forEach(data.items, (subItem, i) => {
          data.items[i].harga_jual = Number(subItem.harga_jual);
          data.items[i].qty = Number(subItem.qty);
          data.items[i].discount = Number(subItem.discount);
          data.items[i].ppn = Number(subItem.ppn);
        });
        this.item_pemasukan.push(data);
      });
    },
    async handlePageSizeChange(size) {
      this.pageSize = size;
      this.currentPage = 1;
      // let payload = {}
      this.item_pemasukan = [];
      let dataItem = {};
      let payload = {
        metode: this.metodeFilter,
        page: this.currentPage,
        jum: this.pageSize,
        search: this.search,
      };

      if (this.selectedStatus) {
        payload.condition = {
          status: this.selectedStatus,
          category_id: this.activeCategory.id,
          type: "PEMASUKAN",
        };
      } else {
        payload.condition = {
          category_id: this.activeCategory.id,
          type: "PEMASUKAN",
        };
      }
      if (this.fromDateFilter && this.toDateFilter) {
        payload.between = {
          from: dayjs(this.fromDateFilter)
            .add(59, "second")
            .format("YYYY-MM-DDTHH:mm:ss"),
          to: dayjs(this.toDateFilter)
            .add(59, "second")
            .format("YYYY-MM-DDTHH:mm:ss"),
        };
      }
      if (payload.between || this.selectedStatus || this.search) {
        const response = await this.filterPemasukan(payload);
        dataItem = response.data;
      } else {
        const dataPagination = {
          category_id: this.activeCategory.id,
          page: this.currentPage,
          jum: this.pageSize,
        };
        dataItem = await this.dataPemasukan(dataPagination);
      }
      // console.log(dataItem)
      this.totalPages = dataItem.submission.last_page;
      this.currentPage = dataItem.submission.current_page;
      this.from = dataItem.submission.from;
      this.to = dataItem.submission.to;
      this.totalData = dataItem.submission.total;
      forEach(dataItem.submission.data, (data, index) => {
        forEach(data.items, (subItem, i) => {
          data.items[i].harga_jual = Number(subItem.harga_jual);
          data.items[i].qty = Number(subItem.qty);
          data.items[i].discount = Number(subItem.discount);
          data.items[i].ppn = Number(subItem.ppn);
        });
        this.item_pemasukan.push(data);
      });
    },

    async editBatasWaktu() {
      let payload = {
        id: this.dataDetails.id,
        due_date: this.editDueDate,
      };
      let response = await this.editDueDateDetail(payload);
      try {
        if (response.data.success) {
          this.dataDetails.due_date = this.editDueDate;
          this.duedateModalVisible = false;
          this.$notify({
            group: "custom-notification",
            type: "success",
            title: "Success!",
            text: response.data.message,
          });
        }
      } catch (e) {
        console.log(e);
      }
    },
  },

  async created() {
    await this.initialize();
    if (this.$route.query.id != undefined) {
      const item = find(
        this.item_pemasukan,
        (item) => item.id == Number(this.$route.query.id)
      );

      if (item != undefined) {
        this.modalDetail(item);
      }
    }
  },
};
</script>
<style>
.v-suggestions input {
  border-bottom: 1px solid #949494 !important;
  width: 100%;
}
</style>
